// // import React, { useEffect, useRef, useState } from "react";
// // import TableHeading from "../../components/common/TableHeading";
// // import Modal from "../../components/common/Model";
// // import TableLayout from "../../components/layouts/table-layout";
// // import BreadCrum from "../../components/common/BreadCrum";
// // import { useTranslation } from "react-i18next";
// // import {
// //   BLOCKAVAILABILITYSUCCESS,
// //   CLOCK_VECTOR,
// //   LIGHTRESTOREBLOCKAVAILABILITY,
// //   PROFILE_IMG,
// //   PROFILE_PICTURE,
// //   RESTOREBLOCKAVAILABILITY,
// // } from "../../utils/aap-image-constant";
// // import Button from "../../components/common/button";
// // import TextArea from "../../components/common/text-area";
// // import {
// //   convertTimeToAmPm,
// //   convertToInputDateFormat,
// //   handleDateChange,
// //   handleFormInput,
// // } from "../../utils/form-utils";
// // import { useLocation, useNavigate } from "react-router-dom";
// // import { API_RESPONSE, DEFAULT_PAGE_LENGTH } from "../../utils/app-constants";
// // import { decryptAEStoJSON, toastEmitter } from "../../utils/utilities";
// // import {
// //   availabiltySlotListDoctorWise,
// //   blockAvailabilitySlotWise,
// //   blockAvailabilty,
// //   blockAvailabiltyDateWise,
// //   getallClinicDoctorAvaialbilty,
// //   restoreBlockAvailabilityAll,
// // } from "../../hooks/services/api-services";
// // import { ROUTES } from "../../hooks/routes/routes-constant";
// // import "react-datepicker/dist/react-datepicker.css";
// // import { useSelector } from "react-redux";
// // import { API_URL } from "../../utils/url-constants";
// // import { TimePicker } from "antd";
// // import dayjs from "dayjs";
// // import Select from "react-select";
// // const BlockAvailability = () => {
// //   const { t, i18n } = useTranslation();
// //   const location = useLocation();
// //   const navigate = useNavigate();
// //   const addbuttonClick = useRef();
// //   const { value } = useSelector((state) => state?.loggedUser);
// //   const userData = decryptAEStoJSON(value);
// //   const isFirstRender = useRef(true);
// //   const [showBlock, setShowBlock] = useState(true);
// //   const [pending, setPending] = useState(false);
// //   const [isLoading, setIsLoading] = useState(false);
// //   const [page, setPage] = useState(0);
// //   const [pageSize, setPageSize] = useState(DEFAULT_PAGE_LENGTH);
// //   const [sortColumn, setSortColumn] = useState("");
// //   const [sortDirection, setSortDirection] = useState("");
// //   const [totalRows, setTotalRows] = useState(0);
// //   const [rowData, setRowData] = useState([]);
// //   const [selectedDate, setSelectedDate] = useState(""); // for DatePicker
// //   // const todayDate = new Date()?.toISOString()?.split("T")[0];
// //   const dateNew = new Date();
// //   const todayDate = isNaN(dateNew) ? null : dateNew.toISOString().split("T")[0];

// //   const [slotAvailabilityCheck, setSlotAvailabilityCheck] = useState([]);

// //   const [blockByDatePayload, setBlockByDatePayload] = useState({
// //     clinicId: location?.state.clinicId || 0,
// //     doctorId: location?.state.doctorId || 0,
// //     date: "",
// //     fromDate: "",
// //     toDate: "",
// //     weekDay: [""],
// //     reason: "",
// //     fromTime: "",
// //     toTime: ""
// //   });

// //   // ----------------------- Slot-wise payload -----------------------
// //   const [blockBySlotPayload, setBlockBySlotPayload] = useState({
// //     clinicId: location?.state.clinicId || 0,
// //     doctorId: location?.state.doctorId || 0,
// //     date: "",
// //     fromDate: "",
// //     toDate: "",
// //     weekDay: [""],
// //     timeSlotId: [0], // default = all slots
// //     reason: "",
// //     fromTime: "",
// //     toTime: ""
// //   });

// //   const handleCheckBox = (id) => {
// //     if (slotAvailabilityCheck?.includes(id)) {
// //       setSlotAvailabilityCheck(slotAvailabilityCheck?.filter((x) => x !== id));
// //     } else {
// //       setSlotAvailabilityCheck([...slotAvailabilityCheck, id]);
// //     }
// //   };
// //  useEffect(() => {
// //   setBlockBySlotPayload((prev) => ({
// //     ...prev,
// //     timeSlotId: slotAvailabilityCheck.length > 0 ? slotAvailabilityCheck : [],
// //   }));
// // }, [slotAvailabilityCheck]);



// //   // view availability sloct list doctor wise
// //   const [offlineSlot, setOfflineSlot] = useState([]);
// //   const [onlineSlot, setOnlineSlot] = useState([]);
// //   const [viewDoctorSlotPayload, setViewDoctorSlotPayload] = useState({
// //     clinicId: userData?.id,
// //     doctorId: location?.state?.doctorId,
// //     date: blockByDatePayload?.date,
// //     languageType: i18n.language,
// //     expertise: ""
// //   });
// //   useEffect(() => {
// //     setViewDoctorSlotPayload((prev) => ({
// //       ...prev,
// //       date: blockByDatePayload?.date,
// //     }));
// //   }, [blockByDatePayload?.date]);

// //   const fetchAvailabilityData = async () => {
// //     try {
// //       const response = await availabiltySlotListDoctorWise(
// //         viewDoctorSlotPayload
// //       );
// //       if (response?.data?.status !== 200) {
// //         if (isFirstRender.current) {
// //           toastEmitter("error", response?.data?.message);
// //         }
// //         setOfflineSlot([]);
// //         setOnlineSlot([]);
// //       } else {
// //         setOfflineSlot(response?.data?.data?.offlineSlots);
// //         setOnlineSlot(response?.data?.data?.onlineSlots);
// //       }
// //     } catch (err) {
// //       if (isFirstRender.current) {
// //         toastEmitter("error", API_RESPONSE?.MESSAGE_503);
// //       }
// //     } finally {
// //       isFirstRender.current = false;
// //     }
// //   };

// //   useEffect(() => {
// //     if (viewDoctorSlotPayload?.doctorId && viewDoctorSlotPayload?.date) {
// //       fetchAvailabilityData();
// //     }
// //   }, [viewDoctorSlotPayload]);

// //   // block availability handle slot and date wise
// //   const handleBlockAvailabilityByDate = async () => {
// //     if (showBlock === true) {
// //       if (blockByDatePayload?.fromDate?.trim() === "") {
// //         return toastEmitter("error", "From date is mandatory!");
// //       }
// //       if (blockByDatePayload?.toDate?.trim() === "") {
// //         return toastEmitter("error", "To date is mandatory!");
// //       }
// //       if (blockByDatePayload?.reason?.trim() === "") {
// //         return toastEmitter("error", "Reason is mandatory!");
// //       }
// //     } else {
// //       // if (blockByDatePayload?.date?.trim() === "") {
// //       //   return toastEmitter("error", "Block Date is mandatory!");
// //       // }
// //       if (blockByDatePayload?.reason?.trim() === "") {
// //         return toastEmitter("error", "Reason is mandatory!");
// //       }
// //       // if (blockBySlotPayload?.timeSlotId?.length === 0) {
// //       //   return toastEmitter("error", "Slot Time is mandatory!");
// //       // }
// //     }

// //   const finalPayload = {
// //     ...blockByDatePayload,
// //      timeSlotId: [0], // 👈 always 0 for full-day blocking
// //     fromTime: "",
// //     toTime: "",
// //   };
// //     setIsLoading(true);
// //     try {
// //       // const response = await blockAvailabiltyDateWise(blockByDatePayload);
// //       const response = await blockAvailabilty(finalPayload);
// //       if (response?.data?.status !== 200) {
// //         toastEmitter("error", response?.data?.message);
// //       } else {

// //         setBlockByDatePayload({
// //           date: "",
// //           clinicId: location?.state.clinicId || 0,
// //           doctorId: location.state.doctorId || 0,
// //           fromDate: "",
// //           toDate: "",
// //           weekDay: [""],
// //           timeSlotId: [0],
// //           reason: "",
// //           fromTime: "",
// //           toTime: "",
// //         });
// //         addbuttonClick.current.click();
// //         getAllBlockAvailabilityList();
// //         setOnlineSlot([]);
// //         setOfflineSlot([]);
// //       }
// //     } catch (err) {
// //       if (isFirstRender.current) {
// //         toastEmitter("error", API_RESPONSE?.MESSAGE_503);
// //       }
// //     } finally {
// //       setIsLoading(false);
// //       isFirstRender.current = false;
// //     }
// //   };

// //   // block availability slot wise
// //   const handleBlockAvailabilityBySlot = async () => {
// //     // if (blockBySlotPayload?.date?.trim() === "") {
// //     //   return toastEmitter("error", "Block Date is mandatory!");
// //     // }
// //     if (blockBySlotPayload?.reason?.trim() === "") {
// //       return toastEmitter("error", "Reason is mandatory!");
// //     }
// //     // if (blockBySlotPayload?.timeSlotId?.length === 0) {
// //     //   return toastEmitter("error", "Slot Time is mandatory!");
// //     // }


// //   const finalPayload = {
// //     ...blockBySlotPayload,
// //     timeSlotId: slotAvailabilityCheck, // 👈 user-selected slots
// //     fromDate: blockBySlotPayload.fromDate,
// //     toDate: blockBySlotPayload.toDate,
// //     fromTime: blockBySlotPayload.fromTime || "",
// //     toTime: blockBySlotPayload.toTime || "",
// //   };
// //     setIsLoading(true);
// //     try {
// //       const response = await blockAvailabilty(finalPayload);
// //       if (response?.data?.status !== 200) {
// //         if (isFirstRender.current) {
// //           toastEmitter("error", response?.data?.message);
// //         }
// //       } else {
// //         setSlotAvailabilityCheck([]);
// //         setBlockBySlotPayload({
// //           clinicId: location?.state.clinicId || 0,
// //           doctorId: location?.state.doctorId || 0,
// //           date: "",
// //           fromDate: "",
// //           toDate: "",
// //           weekDay: [""],
// //           timeSlotId: [0],
// //           reason: "",
// //           fromTime: "",
// //           toTime: ""
// //         });
// //         addbuttonClick?.current?.click();
// //         setOnlineSlot([]);
// //         setOfflineSlot([]);
// //         getAllBlockAvailabilityList();
// //       }
// //     } catch (err) {
// //       if (isFirstRender.current) {
// //         toastEmitter("error", API_RESPONSE?.MESSAGE_503);
// //       }
// //     } finally {
// //       setIsLoading(false);
// //       isFirstRender.current = false;
// //     }
// //   };

// //   const handleDataBack = () => {
// //     navigate(ROUTES.AVAILABILITY);
// //   };

// //   //get all  block availability list
// //   const payload = {
// //     clinicId: location?.state?.clinicId || 0,
// //     doctorId: location?.state?.doctorId,
// //     pageIndex: page || 0,
// //     pageSize: pageSize || DEFAULT_PAGE_LENGTH,
// //     direction: sortDirection || "desc",
// //     date: selectedDate,
// //     filterByFieldName: sortColumn || "id",
// //     languageType: i18n.language,
// //   };

// //   const getAllBlockAvailabilityList = async () => {
// //     setPending(true);
// //     try {
// //       const response = await getallClinicDoctorAvaialbilty(payload);
// //       if (response?.data?.status !== 200) {
// //         setRowData([]);
// //       } else {
// //         setRowData(response?.data?.data);
// //         setTotalRows(response?.data?.data?.totalElement);
// //       }
// //     } catch (err) {
// //       toastEmitter("error", API_RESPONSE?.MESSAGE_503);
// //     } finally {
// //       setPending(false);
// //     }
// //   };

// //   useEffect(() => {
// //     getAllBlockAvailabilityList();
// //   }, [selectedDate, page, pageSize, sortDirection, sortColumn, i18n.language]);

// //   // restore block availability for date and slot
// //   const [selectedSlotId, setSelectedSlotId] = useState(null);
// //   const handleSlotClick = (slotId) => {
// //     setSelectedSlotId((prev) => (prev === slotId ? null : slotId));
// //   };
// //   const handleRestoreBlockAvailability = async (id) => {
// //     try {
// //       const response = await restoreBlockAvailabilityAll(id);
// //       if (response?.data?.status !== 200) {
// //         toastEmitter("error", response?.data?.message);
// //       } else {
// //         toastEmitter("success", response?.data?.message);
// //         setSelectedSlotId(null);
// //         getAllBlockAvailabilityList();
// //       }
// //     } catch (err) {
// //       toastEmitter("error", API_RESPONSE?.MESSAGE_503);
// //     } finally {
// //     }
// //   };

// //   // list of block by date and block by slot
// //   const tableColumns = [
// //     {
// //       name: t("S.No"),
// //       width: "100px",
// //       selector: (row, index) => `${page * pageSize + index + 1}`,
// //     },
// //     {
// //       name: t("Block Date"),
// //       width: "170px",
// //       selector: (row) => row?.date,
// //     },
// //     {
// //       name: t("Block Time"),
// //       width: "400px",
// //       selector: (row) =>
// //         row?.timeSlots?.length === 0 ? (
// //           "Block For Full Day"
// //         ) : (
// //           <>
// //             <div className="table-cell-content d-flex flex-wrap">
// //               {row?.timeSlots &&
// //                 row?.timeSlots?.map((slot, i) => {
// //                   const isSelected = selectedSlotId === slot?.id;
// //                   return (
// //                     <div
// //                       key={slot?.id}
// //                       className={`cursor-pointer me-1 mt-1`} // Add mb-2 for wrapping
// //                       onClick={() => handleSlotClick(slot?.id)}
// //                     >
// //                       <p
// //                         className={`rounded fs-12 p-2 fw-500 mb-0 ${isSelected
// //                           ? "buttonColor text-white"
// //                           : "buttonLightColor"
// //                           }`}
// //                       >
// //                         {convertTimeToAmPm(slot?.fromTime)} -{" "}
// //                         {convertTimeToAmPm(slot?.toTime)}
// //                       </p>
// //                     </div>
// //                   );
// //                 })}
// //             </div>
// //           </>
// //         ),
// //     },
// //     {
// //       name: t("Reason"),
// //       selector: (row) =>
// //         row?.isBlockedByDay ? row.reason : row?.timeSlotReason,
// //     },
// //     {
// //       name: t("Restore Block"),
// //       selector: (row) => row?.date,
// //       cell: (row) => {
// //         const hasNoSlots = row?.timeSlots?.length === 0;
// //         const isSelectedSlotInRow = row?.timeSlots?.some(
// //           (slot) => slot?.id === selectedSlotId
// //         );
// //         const isAnySlotSelected = Boolean(selectedSlotId);
// //         if (hasNoSlots) {
// //           return (
// //             <button
// //               className="unset-property"
// //               onClick={() => handleRestoreBlockAvailability(row?.id)}
// //               disabled={isAnySlotSelected}
// //             >
// //               <img
// //                 src={
// //                   isAnySlotSelected
// //                     ? LIGHTRESTOREBLOCKAVAILABILITY
// //                     : RESTOREBLOCKAVAILABILITY
// //                 }
// //                 alt=""
// //               />
// //             </button>
// //           );
// //         } else {
// //           return (
// //             <button
// //               className="unset-property"
// //               disabled={!isSelectedSlotInRow}
// //               onClick={() => handleRestoreBlockAvailability(selectedSlotId)}
// //             >
// //               <img
// //                 src={
// //                   isSelectedSlotInRow
// //                     ? RESTOREBLOCKAVAILABILITY
// //                     : LIGHTRESTOREBLOCKAVAILABILITY
// //                 }
// //                 alt=""
// //               />
// //             </button>
// //           );
// //         }
// //       },
// //     },
// //   ];

// //   // block week days options
// //   const weekDayOptions = [
// //     { value: "Monday", label: "Monday" },
// //     { value: "Tuesday", label: "Tuesday" },
// //     { value: "Wednesday", label: "Wednesday" },
// //     { value: "Thursday", label: "Thursday" },
// //     { value: "Friday", label: "Friday" },
// //     { value: "Saturday", label: "Saturday" },
// //     { value: "Sunday", label: "Sunday" },
// //   ];

// //   return (
// //     <>
// //       <div className="main_datatable my-lg-3 my-2">
// //         <div>
// //           <BreadCrum
// //             firstData={t("Availability Management")}
// //             iconshow1={true}
// //             secondData={t("Block Availability")}
// //             onFirstDataClick={handleDataBack}
// //           />
// //           <div className="Blockavailability_Content p-2 mb-3">
// //             <div className="d-flex flex-wrap align-items-center mb-3">
// //               <img
// //                 src={
// //                   location?.state?.doctorDetails?.image
// //                     ? `${API_URL?.ServerURL}${location?.state?.doctorDetails?.image}`
// //                     : PROFILE_IMG
// //                 }
// //                 alt="Profile"
// //                 className="rounded-3"
// //                 style={{
// //                   width: "100px",
// //                   height: "100px",
// //                   objectFit: "cover",
// //                   imageRendering: "pixelated",
// //                 }}
// //               />
// //               <div className={` ms-3 ${i18n.language === "ar" ? "me-3" : ""} `}>
// //                 <h5 className="mb-0 fs-6 fw-bolder">
// //                   {" "}
// //                   Dr.{" "}
// //                   {location?.state?.doctorDetails &&
// //                     location?.state?.doctorDetails?.firstName}{" "}
// //                   {location?.state?.doctorDetails &&
// //                     location?.state?.doctorDetails?.lastName}
// //                 </h5>
// //                 <p className="text-muted mb-0">
// //                   {location?.state?.doctorDetails &&
// //                     location?.state?.doctorDetails?.email}
// //                 </p>
// //               </div>
// //             </div>
// //             <div className="d-flex mb-3">
// //               <Button
// //                 label={t("Block By Date")}
// //                 className={` rounded-3 py-2 px-4 fw-500 ${showBlock
// //                   ? "border-0 submitbtn text-white"
// //                   : "textcolor border-sky-blue cursor-pointer bgwhite fs-14"
// //                   }`}
// //                 onClick={() => {
// //                   setShowBlock(!showBlock);
// //                   // setBlockBySlotPayload({
// //                   //   clinicId: location?.state?.clinicId,
// //                   //   doctorId: location?.state?.doctorId,
// //                   //   date: "",
// //                   //   timeSlotId: [],
// //                   //   reason: "",
// //                   // });
// //                   setBlockByDatePayload({
// //                     clinicId: location?.state.clinicId || 0,
// //                     doctorId: location.state.doctorId || 0,
// //                     fromDate: "",
// //                     toDate: "",
// //                     date: "",
// //                     weekDay: [""],
// //                     timeSlotId: [0],
// //                     reason: "",
// //                     fromTime: "",
// //                     toTime: "",
// //                   });

// //                   setOnlineSlot([]);
// //                   setOfflineSlot([]);
// //                 }}
// //               />
// //               <Button
// //                 label={t("Block By slot")}
// //                 className={` ms-2 rounded-3 py-2 px-4 fw-500 ${!showBlock
// //                   ? "border-0 submitbtn text-white"
// //                   : "textcolor cursor-pointer border-sky-blue bgwhite fs-14 "
// //                   } ${i18n.language === "ar" ? "me-0 me-sm-2" : ""}`}
// //                 onClick={() => {
// //                   setShowBlock(!showBlock);
// //                   // setBlockByDatePayload({
// //                   //   ...blockByDatePayload,
// //                   //   clinicId: location?.state?.clinicId || 0,
// //                   //   doctorId: location?.state?.doctorId || 0,
// //                   //   fromDate: "",
// //                   //   toDate: "",
// //                   //   reason: "",
// //                   // });
// //                   setBlockByDatePayload({
// //                     clinicId: location?.state.clinicId || 0,
// //                     doctorId: location.state.doctorId || 0,
// //                     fromDate: "",
// //                     toDate: "",
// //                     date: "",
// //                     weekDay: [""],
// //                     timeSlotId: [0],
// //                     reason: "",
// //                     fromTime: "",
// //                     toTime: "",
// //                   });
// //                 }}
// //               />
// //             </div>
// //             {showBlock ? (
// //               <>
// //                 <div className="row">
// //                   <div className="col-12 col-md-6 col-lg-5">
// //                     <label htmlFor="weekDay" className="mt-0">
// //                       Week Days
// //                     </label>
// //                     <Select
// //                       isMulti
// //                       name="weekDay"
// //                       className="basic-multi-select"
// //                       classNamePrefix="select"
// //                       options={weekDayOptions}
// //                       value={weekDayOptions.filter((opt) =>
// //                         (blockByDatePayload.weekDay || []).includes(opt.value)
// //                       )}
// //                       onChange={(selected) =>
// //                         setBlockByDatePayload({
// //                           ...blockByDatePayload,
// //                           weekDay: selected ? selected.map((s) => s.value) : [""],
// //                         })
// //                       }
// //                     />
// //                   </div>

// //                   <div className="col-12 col-md-6 col-lg-3">
// //                     <label htmlFor="username" className="mt-0">
// //                       {t("From Date")} <span className="text-danger">*</span>
// //                     </label>
// //                     <div
// //                       className={`input-group  ${i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
// //                         }`}
// //                     >
// //                       <span className="input-group-text">
// //                         <img src={CLOCK_VECTOR} alt="clock_vector" />
// //                       </span>
// //                       <input
// //                         type="date"
// //                         className="form-control"
// //                         placeholder={t("fromTime")}
// //                         aria-label={t("fromTime")}
// //                         min={todayDate}
// //                         value={convertToInputDateFormat(
// //                           blockByDatePayload?.fromDate
// //                         )}
// //                         name="fromDate"
// //                         onChange={(e) =>
// //                           setBlockByDatePayload(
// //                             handleDateChange(e, blockByDatePayload)
// //                           )
// //                         }
// //                       />
// //                     </div>
// //                   </div>

// //                   <div className="col-12 col-md-6 col-lg-3">
// //                     <label htmlFor="username" className="mt-0">
// //                       {t("To Date")}
// //                       <span className="text-danger">*</span>
// //                     </label>
// //                     <div
// //                       className={`input-group  ${i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
// //                         }`}
// //                     >
// //                       <span className="input-group-text">
// //                         <img src={CLOCK_VECTOR} alt="clock_vector" />
// //                       </span>
// //                       <input
// //                         type="date"
// //                         className="form-control"
// //                         placeholder="To Time"
// //                         aria-label="To Time"
// //                         min={todayDate}
// //                         value={convertToInputDateFormat(
// //                           blockByDatePayload?.toDate
// //                         )}
// //                         name="toDate"
// //                         onChange={(e) =>
// //                           setBlockByDatePayload(
// //                             handleDateChange(e, blockByDatePayload)
// //                           )
// //                         }
// //                       />
// //                     </div>
// //                   </div>
// //                 </div>
// //                 <div className="row">
// //                   <div className="col-12 col-md-6 col-lg-6">
// //                     <TextArea
// //                       labelName={t("Reason")}
// //                       placeholder={t("Enter Reason")}
// //                       className="mb-3"
// //                       lableclassName="d-flex justify-content-start"
// //                       handleChange={(e) =>
// //                         setBlockByDatePayload(
// //                           handleFormInput(e, blockByDatePayload)
// //                         )
// //                       }
// //                       name="reason"
// //                       value={blockByDatePayload?.reason}
// //                       showastrict={true}
// //                     />
// //                   </div>
// //                 </div>
// //                 <Button
// //                   label={t("Block Date")}
// //                   type="button"
// //                   className="submitbtn border-0 rounded-3 text-white px-5 py-2 fw-500"
// //                   isLoading={isLoading}
// //                   onClick={handleBlockAvailabilityByDate}
// //                 />
// //               </>
// //             ) : (
// //               <>
// //                 <div className="row">
// //                   <div className="col-12 col-md-6 col-lg-4">
// //                     <label htmlFor="weekDay" className="mt-0">
// //                       Week Days
// //                     </label>
// //                     <Select
// //                       isMulti
// //                       name="weekDay"
// //                       className="basic-multi-select"
// //                       classNamePrefix="select"
// //                       options={weekDayOptions}
// //                       value={weekDayOptions.filter((opt) =>
// //                         (blockBySlotPayload.weekDay || []).includes(opt.value)
// //                       )}
// //                       onChange={(selected) =>
// //                         setBlockBySlotPayload({
// //                           ...blockBySlotPayload,
// //                           weekDay: selected ? selected.map((s) => s.value) : [""],
// //                         })
// //                       }
// //                     />
// //                   </div>

// //                   <div className="col-12 col-md-6 col-lg-2">
// //                     <label htmlFor="username" className="mt-0">
// //                       {t("From Date")} <span className="text-danger">*</span>
// //                     </label>
// //                     <div
// //                       className={`input-group  ${i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
// //                         }`}
// //                     >
// //                       <span className="input-group-text">
// //                         <img src={CLOCK_VECTOR} alt="clock_vector" />
// //                       </span>
// //                       <input
// //                         type="date"
// //                         className="form-control"
// //                         placeholder={t("fromTime")}
// //                         aria-label={t("fromTime")}
// //                         min={todayDate}
// //                         value={convertToInputDateFormat(
// //                           blockBySlotPayload?.fromDate
// //                         )}
// //                         name="fromDate"
// //                         onChange={(e) =>
// //                           setBlockBySlotPayload(
// //                             handleDateChange(e, blockBySlotPayload)
// //                           )
// //                         }
// //                       />
// //                     </div>
// //                   </div>

// //                   <div className="col-12 col-md-6 col-lg-2">
// //                     <label htmlFor="username" className="mt-0">
// //                       {t("To Date")}
// //                       <span className="text-danger">*</span>
// //                     </label>
// //                     <div
// //                       className={`input-group  ${i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
// //                         }`}
// //                     >
// //                       <span className="input-group-text">
// //                         <img src={CLOCK_VECTOR} alt="clock_vector" />
// //                       </span>
// //                       <input
// //                         type="date"
// //                         className="form-control"
// //                         placeholder="To Time"
// //                         aria-label="To Time"
// //                         min={todayDate}
// //                         value={convertToInputDateFormat(
// //                           blockBySlotPayload?.toDate
// //                         )}
// //                         name="toDate"
// //                         onChange={(e) =>
// //                           setBlockBySlotPayload(
// //                             handleDateChange(e, blockBySlotPayload)
// //                           )
// //                         }
// //                       />
// //                     </div>
// //                   </div>
// //                   <div className="col-12 col-md-6 col-lg-2">
// //                     <label className="mt-0">From Time</label>
// //                     <TimePicker
// //                       value={
// //                         blockBySlotPayload?.fromTime
// //                           ? dayjs(blockBySlotPayload.fromTime, "HH:mm")
// //                           : null
// //                       }
// //                       className="form-control"
// //                       format="HH:mm"
// //                       placeholder="From"
// //                       onChange={(time) =>
// //                         setBlockBySlotPayload({
// //                           ...blockBySlotPayload,
// //                           fromTime: time ? dayjs(time).format("HH:mm") : ""
// //                         })
// //                       }
// //                     />
// //                   </div>

// //                   <div className="col-12 col-md-6 col-lg-2">
// //                     <label className="mt-0">To Time</label>
// //                     <TimePicker
// //                       value={blockBySlotPayload?.toTime ? dayjs(blockBySlotPayload.toTime, "HH:mm") : null}
// //                       className="form-control"
// //                       format="HH:mm"
// //                       placeholder="To"
// //                       disabled={!blockBySlotPayload.fromTime} // Jab tak fromTime nahi, disable rahega
// //                       disabledTime={() => {
// //                         if (!blockBySlotPayload.fromTime) return {};
// //                         const from = dayjs(blockBySlotPayload.fromTime, "HH:mm");
// //                         return {
// //                           disabledHours: () => Array.from({ length: from.hour() }, (_, i) => i),
// //                           disabledMinutes: (hour) =>
// //                             hour === from.hour() ? Array.from({ length: from.minute() + 1 }, (_, i) => i) : []
// //                         };
// //                       }}
// //                       onChange={(time) =>
// //                         setBlockBySlotPayload({
// //                           ...blockBySlotPayload,
// //                           toTime: time ? dayjs(time).format("HH:mm") : ""
// //                         })
// //                       }
// //                     />


// //                   </div>

// //                   {/* <div className="col-12 col-md-6 col-lg-3">
// //                     <label htmlFor="username" className="mt-0">
// //                       {t("Date")} <span className="text-danger">*</span>
// //                     </label>
// //                     <div className="input-group">
// //                       <span className="input-group-text">
// //                         <img src={CLOCK_VECTOR} alt="clock_vector" />
// //                       </span>
// //                       <input
// //                         type="date"
// //                         label="form Date"
// //                         className="form-control"
// //                         placeholder="From Time"
// //                         min={todayDate}
// //                         value={convertToInputDateFormat(
// //                           blockByDatePayload?.date
// //                         )}
// //                         name="date"
// //                         // onChange={(e) =>
// //                         //   setBlockBySlotPayload(
// //                         //     handleDateChange(e, blockBySlotPayload)
// //                         //   )
// //                         // }
// //                         onChange={(e) =>
// //                           setBlockByDatePayload(
// //                             handleDateChange(e, blockByDatePayload)
// //                           )
// //                         }
// //                       />
// //                     </div>
// //                   </div> */}
// //                   <div className="col-12 col-md-6 col-lg-6 mt-2">
// //                     <TextArea
// //                       labelName={t("Reason")}
// //                       placeholder={t("Enter Reason")}
// //                       lableclassName="d-flex justify-content-start mt-0"
// //                       // handleChange={(e) =>
// //                       //   setBlockBySlotPayload(
// //                       //     handleFormInput(e, blockBySlotPayload)
// //                       //   )
// //                       // }
// //                       handleChange={(e) =>
// //                         setBlockBySlotPayload(
// //                           handleFormInput(e, blockBySlotPayload)
// //                         )
// //                       }
// //                       name="reason"
// //                       value={blockBySlotPayload?.reason}
// //                       showastrict={true}
// //                     />
// //                   </div>
// //                 </div>
// //                 <div className="row">
// //                   <div className="col-12">
// //                     {onlineSlot && onlineSlot?.length !== 0 && (
// //                       <>
// //                         <div className="row">
// //                           <label htmlFor="username" className="mt-0 ">
// //                             Online slots <span className="text-danger ">*</span>
// //                           </label>
// //                           {onlineSlot &&
// //                             onlineSlot?.map((clinicSLot, idx) =>
// //                               clinicSLot?.timeSlots?.map((slot) => {
// //                                 if (slot?.isBlockedByTime) return null;
// //                                 return (
// //                                   <div className="col-auto" key={slot?.id}>
// //                                     <label className="option-block d-flex">
// //                                       <div>
// //                                         <input
// //                                           checked={slotAvailabilityCheck?.includes(
// //                                             slot?.id
// //                                           )}
// //                                           className="form-check-input"
// //                                           type="checkbox"
// //                                           onChange={() =>
// //                                             handleCheckBox(slot?.id)
// //                                           }
// //                                         />
// //                                       </div>
// //                                       <div className="ms-2">
// //                                         {convertTimeToAmPm(slot?.startTime)} -{" "}
// //                                         {convertTimeToAmPm(slot?.endTime)}
// //                                       </div>
// //                                     </label>
// //                                   </div>
// //                                 );
// //                               })
// //                             )}
// //                         </div>
// //                       </>
// //                     )}
// //                     {offlineSlot && offlineSlot?.length !== 0 && (
// //                       <div className="row mt-2">
// //                         <label htmlFor="username" className="mt-0">
// //                           Offline slots <span className="text-danger">*</span>
// //                         </label>
// //                         {offlineSlot &&
// //                           offlineSlot?.map((clinicSLot, idx) =>
// //                             clinicSLot?.timeSlots?.map((slot) => {
// //                               if (slot?.isBlockedByTime) return null; // skip blocked slots

// //                               return (
// //                                 <div className="col-auto" key={slot?.id}>
// //                                   <label className="option-block d-flex">
// //                                     <div>
// //                                       <input
// //                                         checked={slotAvailabilityCheck?.includes(
// //                                           slot?.id
// //                                         )}
// //                                         className="form-check-input"
// //                                         type="checkbox"
// //                                         onChange={() =>
// //                                           handleCheckBox(slot?.id)
// //                                         }
// //                                       />
// //                                     </div>
// //                                     <div className="ms-2">
// //                                       {convertTimeToAmPm(slot?.startTime)} -{" "}
// //                                       {convertTimeToAmPm(slot?.endTime)}
// //                                     </div>
// //                                   </label>
// //                                 </div>
// //                               );
// //                             })
// //                           )}
// //                       </div>
// //                     )}
// //                   </div>
// //                 </div>
// //                 <Button
// //                   label="Block Slot"
// //                   className="submitbtn rounded-3 border-0 text-white px-5 py-2 mt-3 fw-500"
// //                   isLoading={isLoading}
// //                   type="submit"
// //                   // onClick={handleBlockAvailabilityBySlot}
// //                   onClick={handleBlockAvailabilityBySlot}
// //                 />
// //               </>
// //             )}
// //           </div>
// //         </div>

// //         <TableHeading
// //           title={t("Block Availability List")}
// //           showbutton={false}
// //           showDateinput={true}
// //           showsearchinput={false}
// //           selectedDate={selectedDate}
// //           setSelectedDate={setSelectedDate}
// //           todayDate={todayDate}
// //         />
// //         <div className="table-wrapper">
// //           <TableLayout
// //             _tblColumns={tableColumns}
// //             _rowData={rowData}
// //             pending={pending}
// //             pagination={true}
// //             selectableRows={false}
// //             setPending={setPending}
// //             _totalRows={totalRows}
// //             pageSize={pageSize}
// //             setPageSize={setPageSize}
// //             setPage={setPage}
// //             setSortColumn={setSortColumn}
// //             setSortDirection={setSortDirection}
// //           />
// //         </div>
// //         <Modal
// //           modalId="blockavailability"
// //           heading="Availability Blocked"
// //           modalClick={addbuttonClick}
// //           iconsrc={BLOCKAVAILABILITYSUCCESS}
// //           paragraph="Doctor Availability Blocked . You Can Manage it From Block Availability List Section."
// //         />
// //       </div>
// //     </>
// //   );
// // };
// // export default BlockAvailability;





// import React, { useEffect, useRef, useState } from "react";
// import TableHeading from "../../components/common/TableHeading";
// import Modal from "../../components/common/Model";
// import TableLayout from "../../components/layouts/table-layout";
// import BreadCrum from "../../components/common/BreadCrum";
// import { useTranslation } from "react-i18next";
// import {
//   BLOCKAVAILABILITYSUCCESS,
//   CLOCK_VECTOR,
//   LIGHTRESTOREBLOCKAVAILABILITY,
//   PROFILE_IMG,
//   PROFILE_PICTURE,
//   RESTOREBLOCKAVAILABILITY,
// } from "../../utils/aap-image-constant";
// import Button from "../../components/common/button";
// import TextArea from "../../components/common/text-area";
// import {
//   convertTimeToAmPm,
//   convertToInputDateFormat,
//   handleDateChange,
//   handleFormInput,
// } from "../../utils/form-utils";
// import { useLocation, useNavigate } from "react-router-dom";
// import { API_RESPONSE, DEFAULT_PAGE_LENGTH } from "../../utils/app-constants";
// import { decryptAEStoJSON, toastEmitter } from "../../utils/utilities";
// import {
//   availabiltySlotListDoctorWise,
//   blockAvailabilitySlotWise,
//   blockAvailabilty,
//   blockAvailabiltyDateWise,
//   getallClinicDoctorAvaialbilty,
//   restoreBlockAvailabilityAll,
// } from "../../hooks/services/api-services";
// import { ROUTES } from "../../hooks/routes/routes-constant";
// import "react-datepicker/dist/react-datepicker.css";
// import { useSelector } from "react-redux";
// import { API_URL } from "../../utils/url-constants";
// import { TimePicker } from "antd";
// import dayjs from "dayjs";
// import Select from "react-select";
// const BlockAvailability = () => {
//   const { t, i18n } = useTranslation();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const addbuttonClick = useRef();
//   const { value } = useSelector((state) => state?.loggedUser);
//   const userData = decryptAEStoJSON(value);
//   const isFirstRender = useRef(true);
//   const [showBlock, setShowBlock] = useState(true);
//   const [pending, setPending] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [page, setPage] = useState(0);
//   const [pageSize, setPageSize] = useState(DEFAULT_PAGE_LENGTH);
//   const [sortColumn, setSortColumn] = useState("");
//   const [sortDirection, setSortDirection] = useState("");
//   const [totalRows, setTotalRows] = useState(0);
//   const [rowData, setRowData] = useState([]);
//   const [blockType, setBlockType] = useState("date");

//   const [selectedDate, setSelectedDate] = useState(""); // for DatePicker
//   // const todayDate = new Date()?.toISOString()?.split("T")[0];
//   const dateNew = new Date();
//   const todayDate = isNaN(dateNew) ? null : dateNew.toISOString().split("T")[0];

//   const [slotAvailabilityCheck, setSlotAvailabilityCheck] = useState([]);
//   // const [blockByDatePayload, setBlockByDatePayload] = useState({
//   //   clinicId: location?.state.clinicId || 0,
//   //   doctorId: location.state.doctorId || 0,
//   //   fromDate: "",
//   //   toDate: "",
//   //   reason: "",
//   // });
//   const [blockByDatePayload, setBlockByDatePayload] = useState({
//     clinicId: location?.state.clinicId || 0,
//     doctorId: location.state.doctorId || 0,
//     date: "",
//     toDate: "",
//     fromDate: "",
//     weekDay: [""],
//     timeSlotId: [0],
//     reason: "",
//     fromTime: "",
//     toTime: "",
//   });
//   console.log("blockByDatePayload", blockByDatePayload);

//   const [blockBySlotPayload, setBlockBySlotPayload] = useState({
//     clinicId: location?.state?.clinicId,
//     doctorId: location?.state?.doctorId,
//     date: "",
//     timeSlotId: [],
//     reason: "",
//   });

//   const handleCheckBox = (id) => {
//     if (slotAvailabilityCheck?.includes(id)) {
//       setSlotAvailabilityCheck(slotAvailabilityCheck?.filter((x) => x !== id));
//     } else {
//       setSlotAvailabilityCheck([...slotAvailabilityCheck, id]);
//     }
//   };
//   // useEffect(() => {
//   //   setBlockBySlotPayload({
//   //     ...blockBySlotPayload,
//   //     timeSlotId: slotAvailabilityCheck,
//   //   });
//   // }, [slotAvailabilityCheck]);
//   // useEffect(() => {
//   //   setBlockByDatePayload({
//   //     ...blockByDatePayload,
//   //     timeSlotId: slotAvailabilityCheck || [0],
//   //   });
//   // }, [slotAvailabilityCheck]);
//   useEffect(() => {
//     setBlockByDatePayload({
//       ...blockByDatePayload,
//       timeSlotId: slotAvailabilityCheck.length > 0 ? slotAvailabilityCheck : [0],
//     });
//   }, [slotAvailabilityCheck]);

//   // view availability sloct list doctor wise
//   const [offlineSlot, setOfflineSlot] = useState([]);
//   const [onlineSlot, setOnlineSlot] = useState([]);
//   const [viewDoctorSlotPayload, setViewDoctorSlotPayload] = useState({
//     clinicId: userData?.id,
//     doctorId: location?.state?.doctorId,
//     date: blockByDatePayload?.date,
//     languageType: i18n.language,
//     expertise: ""
//   });
//   useEffect(() => {
//     setViewDoctorSlotPayload((prev) => ({
//       ...prev,
//       date: blockByDatePayload?.date,
//     }));
//   }, [blockByDatePayload?.date]);

//   const fetchAvailabilityData = async () => {
//     try {
//       const response = await availabiltySlotListDoctorWise(
//         viewDoctorSlotPayload
//       );
//       if (response?.data?.status !== 200) {
//         if (isFirstRender.current) {
//           toastEmitter("error", response?.data?.message);
//         }
//         setOfflineSlot([]);
//         setOnlineSlot([]);
//       } else {
//         setOfflineSlot(response?.data?.data?.offlineSlots);
//         setOnlineSlot(response?.data?.data?.onlineSlots);
//       }
//     } catch (err) {
//       if (isFirstRender.current) {
//         toastEmitter("error", API_RESPONSE?.MESSAGE_503);
//       }
//     } finally {
//       isFirstRender.current = false;
//     }
//   };

//   useEffect(() => {
//     if (viewDoctorSlotPayload?.doctorId && viewDoctorSlotPayload?.date) {
//       fetchAvailabilityData();
//     }
//   }, [viewDoctorSlotPayload]);

//   // block availability handle slot and date wise
//   const handleBlockAvailabilityByDate = async () => {
//     if (blockType === "date") {
//       if (!blockByDatePayload?.fromDate?.trim()) {
//         return toastEmitter("error", "From date is mandatory!");
//       }
//       if (!blockByDatePayload?.toDate?.trim()) {
//         return toastEmitter("error", "To date is mandatory!");
//       }
//       if (!blockByDatePayload?.reason?.trim()) {
//         return toastEmitter("error", "Reason is mandatory!");
//       }
//     }

//     if (blockType === "slot") {
//       if (!blockByDatePayload?.date?.trim()) {
//         return toastEmitter("error", "Block Date is mandatory!");
//       }
//       if (!blockByDatePayload?.reason?.trim()) {
//         return toastEmitter("error", "Reason is mandatory!");
//       }
//       if (!slotAvailabilityCheck?.length) {
//         return toastEmitter("error", "Select at least one slot!");
//       }
//     }

//     if (blockType === "recurring") {
//       if (!blockByDatePayload?.fromDate?.trim()) {
//         return toastEmitter("error", "From date is mandatory!");
//       }
//       if (!blockByDatePayload?.toDate?.trim()) {
//         return toastEmitter("error", "To date is mandatory!");
//       }
//       if (!blockByDatePayload?.weekDay?.length) {
//         return toastEmitter("error", "Select week days!");
//       }
//       if (!blockByDatePayload?.reason?.trim()) {
//         return toastEmitter("error", "Reason is mandatory!");
//       }
//     }
//     setIsLoading(true);
//     try {
//       // const response = await blockAvailabiltyDateWise(blockByDatePayload);
//       const response = await blockAvailabilty(blockByDatePayload);
//       if (response?.data?.status !== 200) {
//         toastEmitter("error", response?.data?.message);
//       } else {
//         // setBlockByDatePayload({
//         //   clinicId: location?.state?.clinicId || 0,
//         //   doctorId: location?.state?.doctorId || 0,
//         //   fromDate: "",
//         //   toDate: "",
//         //   reason: "",
//         // });
//         setBlockByDatePayload({
//           date: "",
//           clinicId: location?.state.clinicId || 0,
//           doctorId: location.state.doctorId || 0,
//           fromDate: "",
//           toDate: "",
//           weekDay: [""],
//           timeSlotId: [0],
//           reason: "",
//           fromTime: "",
//           toTime: "",
//         });
//         addbuttonClick.current.click();
//         getAllBlockAvailabilityList();
//         setOnlineSlot([]);
//         setOfflineSlot([]);
//       }
//     } catch (err) {
//       if (isFirstRender.current) {
//         toastEmitter("error", API_RESPONSE?.MESSAGE_503);
//       }
//     } finally {
//       setIsLoading(false);
//       isFirstRender.current = false;
//     }
//   };

//   // block availability slot wise
//   const handleBlockAvailabilityBySlot = async () => {
//     if (blockBySlotPayload?.date?.trim() === "") {
//       return toastEmitter("error", "Block Date is mandatory!");
//     }
//     if (blockBySlotPayload?.reason?.trim() === "") {
//       return toastEmitter("error", "Reason is mandatory!");
//     }
//     if (blockBySlotPayload?.timeSlotId?.length === 0) {
//       return toastEmitter("error", "Slot Time is mandatory!");
//     }
//     setIsLoading(true);
//     try {
//       const response = await blockAvailabilitySlotWise(blockBySlotPayload);
//       if (response?.data?.status !== 200) {
//         if (isFirstRender.current) {
//           toastEmitter("error", response?.data?.message);
//         }
//       } else {
//         setSlotAvailabilityCheck([]);
//         setBlockBySlotPayload({
//           clinicId: location?.state?.clinicId,
//           doctorId: location?.state?.doctorId,
//           date: "",
//           timeSlotId: [],
//           reason: "",
//         });
//         addbuttonClick?.current?.click();
//         setOnlineSlot([]);
//         setOfflineSlot([]);
//         getAllBlockAvailabilityList();
//       }
//     } catch (err) {
//       if (isFirstRender.current) {
//         toastEmitter("error", API_RESPONSE?.MESSAGE_503);
//       }
//     } finally {
//       setIsLoading(false);
//       isFirstRender.current = false;
//     }
//   };

//   const handleDataBack = () => {
//     navigate(ROUTES.AVAILABILITY);
//   };

//   //get all  block availability list
//   const payload = {
//     clinicId: location?.state?.clinicId || 0,
//     doctorId: location?.state?.doctorId,
//     pageIndex: page || 0,
//     pageSize: pageSize || DEFAULT_PAGE_LENGTH,
//     direction: sortDirection || "desc",
//     date: selectedDate,
//     filterByFieldName: sortColumn || "id",
//     languageType: i18n.language,
//   };

//   const getAllBlockAvailabilityList = async () => {
//     setPending(true);
//     try {
//       const response = await getallClinicDoctorAvaialbilty(payload);
//       if (response?.data?.status !== 200) {
//         setRowData([]);
//       } else {
//         setRowData(response?.data?.data);
//         setTotalRows(response?.data?.data?.totalElement);
//       }
//     } catch (err) {
//       toastEmitter("error", API_RESPONSE?.MESSAGE_503);
//     } finally {
//       setPending(false);
//     }
//   };

//   useEffect(() => {
//     getAllBlockAvailabilityList();
//   }, [selectedDate, page, pageSize, sortDirection, sortColumn, i18n.language]);

//   // restore block availability for date and slot
//   const [selectedSlotId, setSelectedSlotId] = useState(null);
//   const handleSlotClick = (slotId) => {
//     setSelectedSlotId((prev) => (prev === slotId ? null : slotId));
//   };
//   const handleRestoreBlockAvailability = async (id) => {
//     try {
//       const response = await restoreBlockAvailabilityAll(id);
//       if (response?.data?.status !== 200) {
//         toastEmitter("error", response?.data?.message);
//       } else {
//         toastEmitter("success", response?.data?.message);
//         setSelectedSlotId(null);
//         getAllBlockAvailabilityList();
//       }
//     } catch (err) {
//       toastEmitter("error", API_RESPONSE?.MESSAGE_503);
//     } finally {
//     }
//   };

//   // list of block by date and block by slot
//   const tableColumns = [
//     {
//       name: t("S.No"),
//       width: "100px",
//       selector: (row, index) => `${page * pageSize + index + 1}`,
//     },
//     {
//       name: t("Block Date"),
//       width: "170px",
//       selector: (row) => row?.date,
//     },
//     {
//       name: t("Block Time"),
//       width: "400px",
//       selector: (row) =>
//         row?.timeSlots?.length === 0 ? (
//           "Block For Full Day"
//         ) : (
//           <>
//             <div className="table-cell-content d-flex flex-wrap">
//               {row?.timeSlots &&
//                 row?.timeSlots?.map((slot, i) => {
//                   const isSelected = selectedSlotId === slot?.id;
//                   return (
//                     <div
//                       key={slot?.id}
//                       className={`cursor-pointer me-1 mt-1`} // Add mb-2 for wrapping
//                       onClick={() => handleSlotClick(slot?.id)}
//                     >
//                       <p
//                         className={`rounded fs-12 p-2 fw-500 mb-0 ${isSelected
//                           ? "buttonColor text-white"
//                           : "buttonLightColor"
//                           }`}
//                       >
//                         {convertTimeToAmPm(slot?.fromTime)} -{" "}
//                         {convertTimeToAmPm(slot?.toTime)}
//                       </p>
//                     </div>
//                   );
//                 })}
//             </div>
//           </>
//         ),
//     },
//     {
//       name: t("Reason"),
//       selector: (row) =>
//         row?.isBlockedByDay ? row.reason : row?.timeSlotReason,
//     },
//     {
//       name: t("Restore Block"),
//       selector: (row) => row?.date,
//       cell: (row) => {
//         const hasNoSlots = row?.timeSlots?.length === 0;
//         const isSelectedSlotInRow = row?.timeSlots?.some(
//           (slot) => slot?.id === selectedSlotId
//         );
//         const isAnySlotSelected = Boolean(selectedSlotId);
//         if (hasNoSlots) {
//           return (
//             <button
//               className="unset-property"
//               onClick={() => handleRestoreBlockAvailability(row?.id)}
//               disabled={isAnySlotSelected}
//             >
//               <img
//                 src={
//                   isAnySlotSelected
//                     ? LIGHTRESTOREBLOCKAVAILABILITY
//                     : RESTOREBLOCKAVAILABILITY
//                 }
//                 alt=""
//               />
//             </button>
//           );
//         } else {
//           return (
//             <button
//               className="unset-property"
//               disabled={!isSelectedSlotInRow}
//               onClick={() => handleRestoreBlockAvailability(selectedSlotId)}
//             >
//               <img
//                 src={
//                   isSelectedSlotInRow
//                     ? RESTOREBLOCKAVAILABILITY
//                     : LIGHTRESTOREBLOCKAVAILABILITY
//                 }
//                 alt=""
//               />
//             </button>
//           );
//         }
//       },
//     },
//   ];

//   // block week days options
//   const weekDayOptions = [
//     { value: "Monday", label: "Monday" },
//     { value: "Tuesday", label: "Tuesday" },
//     { value: "Wednesday", label: "Wednesday" },
//     { value: "Thursday", label: "Thursday" },
//     { value: "Friday", label: "Friday" },
//     { value: "Saturday", label: "Saturday" },
//     { value: "Sunday", label: "Sunday" },
//   ];

//   return (
//     <>
//       <div className="main_datatable my-lg-3 my-2">
//         <div>
//           <BreadCrum
//             firstData={t("Availability Management")}
//             iconshow1={true}
//             secondData={t("Block Availability")}
//             onFirstDataClick={handleDataBack}
//           />
//           <div className="Blockavailability_Content p-2 mb-3">
//             <div className="d-flex flex-wrap align-items-center mb-3">
//               <img
//                 src={
//                   location?.state?.doctorDetails?.image
//                     ? `${API_URL?.ServerURL}${location?.state?.doctorDetails?.image}`
//                     : PROFILE_IMG
//                 }
//                 alt="Profile"
//                 className="rounded-3"
//                 style={{
//                   width: "100px",
//                   height: "100px",
//                   objectFit: "cover",
//                   imageRendering: "pixelated",
//                 }}
//               />
//               <div className={` ms-3 ${i18n.language === "ar" ? "me-3" : ""} `}>
//                 <h5 className="mb-0 fs-6 fw-bolder">
//                   {" "}
//                   Dr.{" "}
//                   {location?.state?.doctorDetails &&
//                     location?.state?.doctorDetails?.firstName}{" "}
//                   {location?.state?.doctorDetails &&
//                     location?.state?.doctorDetails?.lastName}
//                 </h5>
//                 <p className="text-muted mb-0">
//                   {location?.state?.doctorDetails &&
//                     location?.state?.doctorDetails?.email}
//                 </p>
//               </div>
//             </div>
//             <div className="d-flex mb-3">
//               <Button
//                 label={t("Block By Date")}
//                 className={` rounded-3 py-2 px-4 fw-500 ${blockType === "date"
//                   ? "border-0 submitbtn text-white"
//                   : "textcolor border-sky-blue cursor-pointer bgwhite fs-14"
//                   }`}

//                 onClick={() => {
//                   setBlockType("date");
//                   setBlockByDatePayload({
//                     clinicId: location?.state.clinicId || 0,
//                     doctorId: location.state.doctorId || 0,
//                     fromDate: "",
//                     toDate: "",
//                     date: "",
//                     weekDay: [""],
//                     timeSlotId: [0],
//                     reason: "",
//                     fromTime: "",
//                     toTime: "",
//                   });

//                   setOnlineSlot([]);
//                   setOfflineSlot([]);
//                 }}
//               />
//               <Button
//                 label={t("Block By slot")}
//                 className={` ms-2 rounded-3 py-2 px-4 fw-500 ${blockType === "slot"
//                   ? "border-0 submitbtn text-white"
//                   : "textcolor cursor-pointer border-sky-blue bgwhite fs-14 "
//                   } ${i18n.language === "ar" ? "me-0 me-sm-2" : ""}`}
//                 onClick={() => {
//                   setBlockType('slot');
//                   setBlockByDatePayload({
//                     clinicId: location?.state.clinicId || 0,
//                     doctorId: location.state.doctorId || 0,
//                     fromDate: "",
//                     toDate: "",
//                     date: "",
//                     weekDay: [""],
//                     timeSlotId: [0],
//                     reason: "",
//                     fromTime: "",
//                     toTime: "",
//                   });
//                 }}
//               />

//               <Button
//                 label={t("Block Recuring")}
//                 className={` ms-2 rounded-3 py-2 px-4 fw-500 ${blockType === "recurring"
//                   ? "border-0 submitbtn text-white"
//                   : "textcolor cursor-pointer border-sky-blue bgwhite fs-14 "
//                   } ${i18n.language === "ar" ? "me-0 me-sm-2" : ""}`}
//                 onClick={() => {
//                   setBlockType('recurring');
//                   setBlockByDatePayload({
//                     clinicId: location?.state.clinicId || 0,
//                     doctorId: location.state.doctorId || 0,
//                     fromDate: "",
//                     toDate: "",
//                     date: "",
//                     weekDay: [""],
//                     timeSlotId: [0],
//                     reason: "",
//                     fromTime: "",
//                     toTime: "",
//                   });
//                 }}
//               />
//             </div>
//             {blockType === "date" && (
//               <>
//                 <div className="row">
//                   <div className="col-12 col-md-6 col-lg-5">
//                     <label htmlFor="weekDay" className="mt-0">
//                       Week Days
//                     </label>
//                     <Select
//                       isMulti
//                       name="weekDay"
//                       className="basic-multi-select"
//                       classNamePrefix="select"
//                       options={weekDayOptions}
//                       value={weekDayOptions.filter((opt) =>
//                         (blockByDatePayload.weekDay || []).includes(opt.value)
//                       )}
//                       onChange={(selected) =>
//                         setBlockByDatePayload({
//                           ...blockByDatePayload,
//                           weekDay: selected ? selected.map((s) => s.value) : [""],
//                         })
//                       }
//                     />
//                   </div>

//                   <div className="col-12 col-md-6 col-lg-3">
//                     <label htmlFor="username" className="mt-0">
//                       {t("From Date")} <span className="text-danger">*</span>
//                     </label>
//                     <div
//                       className={`input-group  ${i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
//                         }`}
//                     >
//                       <span className="input-group-text">
//                         <img src={CLOCK_VECTOR} alt="clock_vector" />
//                       </span>
//                       <input
//                         type="date"
//                         className="form-control"
//                         placeholder={t("fromTime")}
//                         aria-label={t("fromTime")}
//                         min={todayDate}
//                         value={convertToInputDateFormat(
//                           blockByDatePayload?.fromDate
//                         )}
//                         name="fromDate"
//                         onChange={(e) =>
//                           setBlockByDatePayload(
//                             handleDateChange(e, blockByDatePayload)
//                           )
//                         }
//                       />
//                     </div>
//                   </div>

//                   <div className="col-12 col-md-6 col-lg-3">
//                     <label htmlFor="username" className="mt-0">
//                       {t("To Date")}
//                       <span className="text-danger">*</span>
//                     </label>
//                     <div
//                       className={`input-group  ${i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
//                         }`}
//                     >
//                       <span className="input-group-text">
//                         <img src={CLOCK_VECTOR} alt="clock_vector" />
//                       </span>
//                       <input
//                         type="date"
//                         className="form-control"
//                         placeholder="To Time"
//                         aria-label="To Time"
//                         min={todayDate}
//                         value={convertToInputDateFormat(
//                           blockByDatePayload?.toDate
//                         )}
//                         name="toDate"
//                         onChange={(e) =>
//                           setBlockByDatePayload(
//                             handleDateChange(e, blockByDatePayload)
//                           )
//                         }
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="col-12 col-md-6 col-lg-6">
//                     <TextArea
//                       labelName={t("Reason")}
//                       placeholder={t("Enter Reason")}
//                       className="mb-3"
//                       lableclassName="d-flex justify-content-start"
//                       handleChange={(e) =>
//                         setBlockByDatePayload(
//                           handleFormInput(e, blockByDatePayload)
//                         )
//                       }
//                       name="reason"
//                       value={blockByDatePayload?.reason}
//                       showastrict={true}
//                     />
//                   </div>
//                 </div>
//                 <Button
//                   label={t("Block Date")}
//                   type="button"
//                   className="submitbtn border-0 rounded-3 text-white px-5 py-2 fw-500"
//                   isLoading={isLoading}
//                   onClick={handleBlockAvailabilityByDate}
//                 />
//               </>
//             )}
//             {blockType === "slot" && (
//               <>
//                 <div className="row">
//                   <div className="col-12 col-md-6 col-lg-3">
//                     <label className="mt-0">From Time</label>
//                     <TimePicker
//                       value={
//                         blockByDatePayload?.fromTime
//                           ? dayjs(blockByDatePayload.fromTime, "HH:mm")
//                           : null
//                       }
//                       className="form-control"
//                       format="HH:mm"
//                       placeholder="From"
//                       onChange={(time) =>
//                         setBlockByDatePayload({
//                           ...blockByDatePayload,
//                           fromTime: time ? dayjs(time).format("HH:mm") : ""
//                         })
//                       }
//                     />
//                   </div>

//                   <div className="col-12 col-md-6 col-lg-3">
//                     <label className="mt-0">To Time</label>
//                     <TimePicker
//                       value={blockByDatePayload?.toTime ? dayjs(blockByDatePayload.toTime, "HH:mm") : null}
//                       className="form-control"
//                       format="HH:mm"
//                       placeholder="To"
//                       disabled={!blockByDatePayload.fromTime} // Jab tak fromTime nahi, disable rahega
//                       disabledTime={() => {
//                         if (!blockByDatePayload.fromTime) return {};
//                         const from = dayjs(blockByDatePayload.fromTime, "HH:mm");
//                         return {
//                           disabledHours: () => Array.from({ length: from.hour() }, (_, i) => i),
//                           disabledMinutes: (hour) =>
//                             hour === from.hour() ? Array.from({ length: from.minute() + 1 }, (_, i) => i) : []
//                         };
//                       }}
//                       onChange={(time) =>
//                         setBlockByDatePayload({
//                           ...blockByDatePayload,
//                           toTime: time ? dayjs(time).format("HH:mm") : ""
//                         })
//                       }
//                     />


//                   </div>

//                   <div className="col-12 col-md-6 col-lg-3">
//                     <label htmlFor="username" className="mt-0">
//                       {t("Date")} <span className="text-danger">*</span>
//                     </label>
//                     <div className="input-group">
//                       <span className="input-group-text">
//                         <img src={CLOCK_VECTOR} alt="clock_vector" />
//                       </span>
//                       <input
//                         type="date"
//                         label="form Date"
//                         className="form-control"
//                         placeholder="From Time"
//                         min={todayDate}
//                         value={convertToInputDateFormat(
//                           blockByDatePayload?.date
//                         )}
//                         name="date"
//                         // onChange={(e) =>
//                         //   setBlockBySlotPayload(
//                         //     handleDateChange(e, blockBySlotPayload)
//                         //   )
//                         // }
//                         onChange={(e) =>
//                           setBlockByDatePayload(
//                             handleDateChange(e, blockByDatePayload)
//                           )
//                         }
//                       />
//                     </div>
//                   </div>
//                   <div className="col-12 col-md-6 col-lg-6 mt-2">
//                     <TextArea
//                       labelName={t("Reason")}
//                       placeholder={t("Enter Reason")}
//                       lableclassName="d-flex justify-content-start mt-0"
//                       // handleChange={(e) =>
//                       //   setBlockBySlotPayload(
//                       //     handleFormInput(e, blockBySlotPayload)
//                       //   )
//                       // }
//                       handleChange={(e) =>
//                         setBlockByDatePayload(
//                           handleFormInput(e, blockByDatePayload)
//                         )
//                       }
//                       name="reason"
//                       value={blockByDatePayload?.reason}
//                       showastrict={true}
//                     />
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="col-12">
//                     {onlineSlot && onlineSlot?.length !== 0 && (
//                       <>
//                         <div className="row">
//                           <label htmlFor="username" className="mt-0 ">
//                             Online slots <span className="text-danger ">*</span>
//                           </label>
//                           {onlineSlot &&
//                             onlineSlot?.map((clinicSLot, idx) =>
//                               clinicSLot?.timeSlots?.map((slot) => {
//                                 if (slot?.isBlockedByTime) return null;
//                                 return (
//                                   <div className="col-auto" key={slot?.id}>
//                                     <label className="option-block d-flex">
//                                       <div>
//                                         <input
//                                           checked={slotAvailabilityCheck?.includes(
//                                             slot?.id
//                                           )}
//                                           className="form-check-input"
//                                           type="checkbox"
//                                           onChange={() =>
//                                             handleCheckBox(slot?.id)
//                                           }
//                                         />
//                                       </div>
//                                       <div className="ms-2">
//                                         {convertTimeToAmPm(slot?.startTime)} -{" "}
//                                         {convertTimeToAmPm(slot?.endTime)}
//                                       </div>
//                                     </label>
//                                   </div>
//                                 );
//                               })
//                             )}
//                         </div>
//                       </>
//                     )}
//                     {offlineSlot && offlineSlot?.length !== 0 && (
//                       <div className="row mt-2">
//                         <label htmlFor="username" className="mt-0">
//                           Offline slots <span className="text-danger">*</span>
//                         </label>
//                         {offlineSlot &&
//                           offlineSlot?.map((clinicSLot, idx) =>
//                             clinicSLot?.timeSlots?.map((slot) => {
//                               if (slot?.isBlockedByTime) return null; // skip blocked slots

//                               return (
//                                 <div className="col-auto" key={slot?.id}>
//                                   <label className="option-block d-flex">
//                                     <div>
//                                       <input
//                                         checked={slotAvailabilityCheck?.includes(
//                                           slot?.id
//                                         )}
//                                         className="form-check-input"
//                                         type="checkbox"
//                                         onChange={() =>
//                                           handleCheckBox(slot?.id)
//                                         }
//                                       />
//                                     </div>
//                                     <div className="ms-2">
//                                       {convertTimeToAmPm(slot?.startTime)} -{" "}
//                                       {convertTimeToAmPm(slot?.endTime)}
//                                     </div>
//                                   </label>
//                                 </div>
//                               );
//                             })
//                           )}
//                       </div>
//                     )}
//                   </div>
//                 </div>
//                 <Button
//                   label="Block Slot"
//                   className="submitbtn rounded-3 border-0 text-white px-5 py-2 mt-3 fw-500"
//                   isLoading={isLoading}
//                   type="submit"
//                   // onClick={handleBlockAvailabilityBySlot}
//                   onClick={handleBlockAvailabilityByDate}
//                 />
//               </>
//             )}

//             {blockType === "recurring" && (
//               <>
//                 <div className="row">
//                   <div className="col-12 col-md-6 col-lg-4">
//                     <label>Week Days</label>
//                     <Select
//                       isMulti
//                       name="weekDay"
//                       classNamePrefix="select"
//                       options={weekDayOptions}
//                       value={weekDayOptions.filter((opt) =>
//                         (blockByDatePayload.weekDay || []).includes(opt.value)
//                       )}
//                       onChange={(selected) =>
//                         setBlockByDatePayload({
//                           ...blockByDatePayload,
//                           weekDay: selected ? selected.map((s) => s.value) : [],
//                         })
//                       }
//                     />
//                   </div>

//                   <div className="col-12 col-md-6 col-lg-4">
//                     <label>From Date</label>
//                     <input
//                       type="date"
//                       className="form-control"
//                       value={convertToInputDateFormat(blockByDatePayload?.fromDate)}
//                       name="fromDate"
//                       onChange={(e) =>
//                         setBlockByDatePayload(handleDateChange(e, blockByDatePayload))
//                       }
//                     />
//                   </div>

//                   <div className="col-12 col-md-6 col-lg-4">

//                     <label>To Date</label>
//                     <input
//                       type="date"
//                       className="form-control"
//                       value={convertToInputDateFormat(blockByDatePayload?.toDate)}
//                       name="toDate"
//                       onChange={(e) =>
//                         setBlockByDatePayload(handleDateChange(e, blockByDatePayload))
//                       }
//                     />
//                   </div>
//                 </div>

//                 <div className="row mt-3">
//                   <div className="col-12 col-md-6 col-lg-4">
//                       <label className="mt-0">From Time</label>
//                       <TimePicker
//                         value={
//                           blockByDatePayload?.fromTime
//                             ? dayjs(blockByDatePayload.fromTime, "HH:mm")
//                             : null
//                         }
//                         className="form-control"
//                         format="HH:mm"
//                         placeholder="From"
//                         onChange={(time) =>
//                           setBlockByDatePayload({
//                             ...blockByDatePayload,
//                             fromTime: time ? dayjs(time).format("HH:mm") : ""
//                           })
//                         }
//                       />
//                   </div>

//                   <div className="col-12 col-md-6 col-lg-4">
//                     <label className="mt-0">To Time</label>
//                     <TimePicker
//                       value={
//                         blockByDatePayload?.toTime
//                           ? dayjs(blockByDatePayload.toTime, "HH:mm")
//                           : null
//                       }
//                       className="form-control"
//                       format="HH:mm"
//                       placeholder="To"
//                       onChange={(time) =>
//                         setBlockByDatePayload({
//                           ...blockByDatePayload,
//                           toTime: time ? dayjs(time).format("HH:mm") : ""
//                         })
//                       }
//                     />
//                   </div>
//                 </div>

//                 <div className="row mt-3">
//                   <div className="col-12 col-md-6">
//                     <TextArea
//                       labelName={t("Reason")}
//                       placeholder={t("Enter Reason")}
//                       handleChange={(e) =>
//                         setBlockByDatePayload(handleFormInput(e, blockByDatePayload))
//                       }
//                       name="reason"
//                       value={blockByDatePayload?.reason}
//                       showastrict={true}
//                     />
//                   </div>
//                 </div>

//                 <Button
//                   label="Block Recurring"
//                   className="submitbtn rounded-3 border-0 text-white px-5 py-2 mt-3 fw-500"
//                   isLoading={isLoading}
//                   onClick={handleBlockAvailabilityByDate}
//                 />
//               </>
//             )}
//           </div>
//         </div>

//         <TableHeading
//           title={t("Block Availability List")}
//           showbutton={false}
//           showDateinput={true}
//           showsearchinput={false}
//           selectedDate={selectedDate}
//           setSelectedDate={setSelectedDate}
//           todayDate={todayDate}
//         />
//         <div className="table-wrapper">
//           <TableLayout
//             _tblColumns={tableColumns}
//             _rowData={rowData}
//             pending={pending}
//             pagination={true}
//             selectableRows={false}
//             setPending={setPending}
//             _totalRows={totalRows}
//             pageSize={pageSize}
//             setPageSize={setPageSize}
//             setPage={setPage}
//             setSortColumn={setSortColumn}
//             setSortDirection={setSortDirection}
//           />
//         </div>
//         <Modal
//           modalId="blockavailability"
//           heading="Availability Blocked"
//           modalClick={addbuttonClick}
//           iconsrc={BLOCKAVAILABILITYSUCCESS}
//           paragraph="Doctor Availability Blocked . You Can Manage it From Block Availability List Section."
//         />
//       </div>
//     </>
//   );
// };
// export default BlockAvailability;


// import React, { useEffect, useRef, useState } from "react";
// import TableHeading from "../../components/common/TableHeading";
// import Modal from "../../components/common/Model";
// import TableLayout from "../../components/layouts/table-layout";
// import BreadCrum from "../../components/common/BreadCrum";
// import { useTranslation } from "react-i18next";
// import {
//   BLOCKAVAILABILITYSUCCESS,
//   CLOCK_VECTOR,
//   LIGHTRESTOREBLOCKAVAILABILITY,
//   PROFILE_IMG,
//   PROFILE_PICTURE,
//   RESTOREBLOCKAVAILABILITY,
// } from "../../utils/aap-image-constant";
// import Button from "../../components/common/button";
// import TextArea from "../../components/common/text-area";
// import {
//   convertTimeToAmPm,
//   convertToInputDateFormat,
//   handleDateChange,
//   handleFormInput,
// } from "../../utils/form-utils";
// import { useLocation, useNavigate } from "react-router-dom";
// import { API_RESPONSE, DEFAULT_PAGE_LENGTH } from "../../utils/app-constants";
// import { decryptAEStoJSON, toastEmitter } from "../../utils/utilities";
// import {
//   availabiltySlotListDoctorWise,
//   blockAvailabilitySlotWise,
//   blockAvailabilty,
//   blockAvailabiltyDateWise,
//   getallClinicDoctorAvaialbilty,
//   restoreBlockAvailabilityAll,
// } from "../../hooks/services/api-services";
// import { ROUTES } from "../../hooks/routes/routes-constant";
// import "react-datepicker/dist/react-datepicker.css";
// import { useSelector } from "react-redux";
// import { API_URL } from "../../utils/url-constants";
// import { TimePicker } from "antd";
// import dayjs from "dayjs";
// import Select from "react-select";
// const BlockAvailability = () => {
//   const { t, i18n } = useTranslation();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const addbuttonClick = useRef();
//   const { value } = useSelector((state) => state?.loggedUser);
//   const userData = decryptAEStoJSON(value);
//   const isFirstRender = useRef(true);
//   const [showBlock, setShowBlock] = useState(true);
//   const [pending, setPending] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [page, setPage] = useState(0);
//   const [pageSize, setPageSize] = useState(DEFAULT_PAGE_LENGTH);
//   const [sortColumn, setSortColumn] = useState("");
//   const [sortDirection, setSortDirection] = useState("");
//   const [totalRows, setTotalRows] = useState(0);
//   const [rowData, setRowData] = useState([]);
//   const [selectedDate, setSelectedDate] = useState(""); // for DatePicker
//   // const todayDate = new Date()?.toISOString()?.split("T")[0];
//   const dateNew = new Date();
//   const todayDate = isNaN(dateNew) ? null : dateNew.toISOString().split("T")[0];

//   const [slotAvailabilityCheck, setSlotAvailabilityCheck] = useState([]);

//   const [blockByDatePayload, setBlockByDatePayload] = useState({
//     clinicId: location?.state.clinicId || 0,
//     doctorId: location?.state.doctorId || 0,
//     date: "",
//     fromDate: "",
//     toDate: "",
//     weekDay: [""],
//     reason: "",
//     fromTime: "",
//     toTime: ""
//   });

//   // ----------------------- Slot-wise payload -----------------------
//   const [blockBySlotPayload, setBlockBySlotPayload] = useState({
//     clinicId: location?.state.clinicId || 0,
//     doctorId: location?.state.doctorId || 0,
//     date: "",
//     fromDate: "",
//     toDate: "",
//     weekDay: [""],
//     timeSlotId: [0], // default = all slots
//     reason: "",
//     fromTime: "",
//     toTime: ""
//   });

//   const handleCheckBox = (id) => {
//     if (slotAvailabilityCheck?.includes(id)) {
//       setSlotAvailabilityCheck(slotAvailabilityCheck?.filter((x) => x !== id));
//     } else {
//       setSlotAvailabilityCheck([...slotAvailabilityCheck, id]);
//     }
//   };
//  useEffect(() => {
//   setBlockBySlotPayload((prev) => ({
//     ...prev,
//     timeSlotId: slotAvailabilityCheck.length > 0 ? slotAvailabilityCheck : [],
//   }));
// }, [slotAvailabilityCheck]);



//   // view availability sloct list doctor wise
//   const [offlineSlot, setOfflineSlot] = useState([]);
//   const [onlineSlot, setOnlineSlot] = useState([]);
//   const [viewDoctorSlotPayload, setViewDoctorSlotPayload] = useState({
//     clinicId: userData?.id,
//     doctorId: location?.state?.doctorId,
//     date: blockByDatePayload?.date,
//     languageType: i18n.language,
//     expertise: ""
//   });
//   useEffect(() => {
//     setViewDoctorSlotPayload((prev) => ({
//       ...prev,
//       date: blockByDatePayload?.date,
//     }));
//   }, [blockByDatePayload?.date]);

//   const fetchAvailabilityData = async () => {
//     try {
//       const response = await availabiltySlotListDoctorWise(
//         viewDoctorSlotPayload
//       );
//       if (response?.data?.status !== 200) {
//         if (isFirstRender.current) {
//           toastEmitter("error", response?.data?.message);
//         }
//         setOfflineSlot([]);
//         setOnlineSlot([]);
//       } else {
//         setOfflineSlot(response?.data?.data?.offlineSlots);
//         setOnlineSlot(response?.data?.data?.onlineSlots);
//       }
//     } catch (err) {
//       if (isFirstRender.current) {
//         toastEmitter("error", API_RESPONSE?.MESSAGE_503);
//       }
//     } finally {
//       isFirstRender.current = false;
//     }
//   };

//   useEffect(() => {
//     if (viewDoctorSlotPayload?.doctorId && viewDoctorSlotPayload?.date) {
//       fetchAvailabilityData();
//     }
//   }, [viewDoctorSlotPayload]);

//   // block availability handle slot and date wise
//   const handleBlockAvailabilityByDate = async () => {
//     if (showBlock === true) {
//       if (blockByDatePayload?.fromDate?.trim() === "") {
//         return toastEmitter("error", "From date is mandatory!");
//       }
//       if (blockByDatePayload?.toDate?.trim() === "") {
//         return toastEmitter("error", "To date is mandatory!");
//       }
//       if (blockByDatePayload?.reason?.trim() === "") {
//         return toastEmitter("error", "Reason is mandatory!");
//       }
//     } else {
//       // if (blockByDatePayload?.date?.trim() === "") {
//       //   return toastEmitter("error", "Block Date is mandatory!");
//       // }
//       if (blockByDatePayload?.reason?.trim() === "") {
//         return toastEmitter("error", "Reason is mandatory!");
//       }
//       // if (blockBySlotPayload?.timeSlotId?.length === 0) {
//       //   return toastEmitter("error", "Slot Time is mandatory!");
//       // }
//     }

//   const finalPayload = {
//     ...blockByDatePayload,
//      timeSlotId: [0], // 👈 always 0 for full-day blocking
//     fromTime: "",
//     toTime: "",
//   };
//     setIsLoading(true);
//     try {
//       // const response = await blockAvailabiltyDateWise(blockByDatePayload);
//       const response = await blockAvailabilty(finalPayload);
//       if (response?.data?.status !== 200) {
//         toastEmitter("error", response?.data?.message);
//       } else {

//         setBlockByDatePayload({
//           date: "",
//           clinicId: location?.state.clinicId || 0,
//           doctorId: location.state.doctorId || 0,
//           fromDate: "",
//           toDate: "",
//           weekDay: [""],
//           timeSlotId: [0],
//           reason: "",
//           fromTime: "",
//           toTime: "",
//         });
//         addbuttonClick.current.click();
//         getAllBlockAvailabilityList();
//         setOnlineSlot([]);
//         setOfflineSlot([]);
//       }
//     } catch (err) {
//       if (isFirstRender.current) {
//         toastEmitter("error", API_RESPONSE?.MESSAGE_503);
//       }
//     } finally {
//       setIsLoading(false);
//       isFirstRender.current = false;
//     }
//   };

//   // block availability slot wise
//   const handleBlockAvailabilityBySlot = async () => {
//     // if (blockBySlotPayload?.date?.trim() === "") {
//     //   return toastEmitter("error", "Block Date is mandatory!");
//     // }
//     if (blockBySlotPayload?.reason?.trim() === "") {
//       return toastEmitter("error", "Reason is mandatory!");
//     }
//     // if (blockBySlotPayload?.timeSlotId?.length === 0) {
//     //   return toastEmitter("error", "Slot Time is mandatory!");
//     // }


//   const finalPayload = {
//     ...blockBySlotPayload,
//     timeSlotId: slotAvailabilityCheck, // 👈 user-selected slots
//     fromDate: blockBySlotPayload.fromDate,
//     toDate: blockBySlotPayload.toDate,
//     fromTime: blockBySlotPayload.fromTime || "",
//     toTime: blockBySlotPayload.toTime || "",
//   };
//     setIsLoading(true);
//     try {
//       const response = await blockAvailabilty(finalPayload);
//       if (response?.data?.status !== 200) {
//         if (isFirstRender.current) {
//           toastEmitter("error", response?.data?.message);
//         }
//       } else {
//         setSlotAvailabilityCheck([]);
//         setBlockBySlotPayload({
//           clinicId: location?.state.clinicId || 0,
//           doctorId: location?.state.doctorId || 0,
//           date: "",
//           fromDate: "",
//           toDate: "",
//           weekDay: [""],
//           timeSlotId: [0],
//           reason: "",
//           fromTime: "",
//           toTime: ""
//         });
//         addbuttonClick?.current?.click();
//         setOnlineSlot([]);
//         setOfflineSlot([]);
//         getAllBlockAvailabilityList();
//       }
//     } catch (err) {
//       if (isFirstRender.current) {
//         toastEmitter("error", API_RESPONSE?.MESSAGE_503);
//       }
//     } finally {
//       setIsLoading(false);
//       isFirstRender.current = false;
//     }
//   };

//   const handleDataBack = () => {
//     navigate(ROUTES.AVAILABILITY);
//   };

//   //get all  block availability list
//   const payload = {
//     clinicId: location?.state?.clinicId || 0,
//     doctorId: location?.state?.doctorId,
//     pageIndex: page || 0,
//     pageSize: pageSize || DEFAULT_PAGE_LENGTH,
//     direction: sortDirection || "desc",
//     date: selectedDate,
//     filterByFieldName: sortColumn || "id",
//     languageType: i18n.language,
//   };

//   const getAllBlockAvailabilityList = async () => {
//     setPending(true);
//     try {
//       const response = await getallClinicDoctorAvaialbilty(payload);
//       if (response?.data?.status !== 200) {
//         setRowData([]);
//       } else {
//         setRowData(response?.data?.data);
//         setTotalRows(response?.data?.data?.totalElement);
//       }
//     } catch (err) {
//       toastEmitter("error", API_RESPONSE?.MESSAGE_503);
//     } finally {
//       setPending(false);
//     }
//   };

//   useEffect(() => {
//     getAllBlockAvailabilityList();
//   }, [selectedDate, page, pageSize, sortDirection, sortColumn, i18n.language]);

//   // restore block availability for date and slot
//   const [selectedSlotId, setSelectedSlotId] = useState(null);
//   const handleSlotClick = (slotId) => {
//     setSelectedSlotId((prev) => (prev === slotId ? null : slotId));
//   };
//   const handleRestoreBlockAvailability = async (id) => {
//     try {
//       const response = await restoreBlockAvailabilityAll(id);
//       if (response?.data?.status !== 200) {
//         toastEmitter("error", response?.data?.message);
//       } else {
//         toastEmitter("success", response?.data?.message);
//         setSelectedSlotId(null);
//         getAllBlockAvailabilityList();
//       }
//     } catch (err) {
//       toastEmitter("error", API_RESPONSE?.MESSAGE_503);
//     } finally {
//     }
//   };

//   // list of block by date and block by slot
//   const tableColumns = [
//     {
//       name: t("S.No"),
//       width: "100px",
//       selector: (row, index) => `${page * pageSize + index + 1}`,
//     },
//     {
//       name: t("Block Date"),
//       width: "170px",
//       selector: (row) => row?.date,
//     },
//     {
//       name: t("Block Time"),
//       width: "400px",
//       selector: (row) =>
//         row?.timeSlots?.length === 0 ? (
//           "Block For Full Day"
//         ) : (
//           <>
//             <div className="table-cell-content d-flex flex-wrap">
//               {row?.timeSlots &&
//                 row?.timeSlots?.map((slot, i) => {
//                   const isSelected = selectedSlotId === slot?.id;
//                   return (
//                     <div
//                       key={slot?.id}
//                       className={`cursor-pointer me-1 mt-1`} // Add mb-2 for wrapping
//                       onClick={() => handleSlotClick(slot?.id)}
//                     >
//                       <p
//                         className={`rounded fs-12 p-2 fw-500 mb-0 ${isSelected
//                           ? "buttonColor text-white"
//                           : "buttonLightColor"
//                           }`}
//                       >
//                         {convertTimeToAmPm(slot?.fromTime)} -{" "}
//                         {convertTimeToAmPm(slot?.toTime)}
//                       </p>
//                     </div>
//                   );
//                 })}
//             </div>
//           </>
//         ),
//     },
//     {
//       name: t("Reason"),
//       selector: (row) =>
//         row?.isBlockedByDay ? row.reason : row?.timeSlotReason,
//     },
//     {
//       name: t("Restore Block"),
//       selector: (row) => row?.date,
//       cell: (row) => {
//         const hasNoSlots = row?.timeSlots?.length === 0;
//         const isSelectedSlotInRow = row?.timeSlots?.some(
//           (slot) => slot?.id === selectedSlotId
//         );
//         const isAnySlotSelected = Boolean(selectedSlotId);
//         if (hasNoSlots) {
//           return (
//             <button
//               className="unset-property"
//               onClick={() => handleRestoreBlockAvailability(row?.id)}
//               disabled={isAnySlotSelected}
//             >
//               <img
//                 src={
//                   isAnySlotSelected
//                     ? LIGHTRESTOREBLOCKAVAILABILITY
//                     : RESTOREBLOCKAVAILABILITY
//                 }
//                 alt=""
//               />
//             </button>
//           );
//         } else {
//           return (
//             <button
//               className="unset-property"
//               disabled={!isSelectedSlotInRow}
//               onClick={() => handleRestoreBlockAvailability(selectedSlotId)}
//             >
//               <img
//                 src={
//                   isSelectedSlotInRow
//                     ? RESTOREBLOCKAVAILABILITY
//                     : LIGHTRESTOREBLOCKAVAILABILITY
//                 }
//                 alt=""
//               />
//             </button>
//           );
//         }
//       },
//     },
//   ];

//   // block week days options
//   const weekDayOptions = [
//     { value: "Monday", label: "Monday" },
//     { value: "Tuesday", label: "Tuesday" },
//     { value: "Wednesday", label: "Wednesday" },
//     { value: "Thursday", label: "Thursday" },
//     { value: "Friday", label: "Friday" },
//     { value: "Saturday", label: "Saturday" },
//     { value: "Sunday", label: "Sunday" },
//   ];

//   return (
//     <>
//       <div className="main_datatable my-lg-3 my-2">
//         <div>
//           <BreadCrum
//             firstData={t("Availability Management")}
//             iconshow1={true}
//             secondData={t("Block Availability")}
//             onFirstDataClick={handleDataBack}
//           />
//           <div className="Blockavailability_Content p-2 mb-3">
//             <div className="d-flex flex-wrap align-items-center mb-3">
//               <img
//                 src={
//                   location?.state?.doctorDetails?.image
//                     ? `${API_URL?.ServerURL}${location?.state?.doctorDetails?.image}`
//                     : PROFILE_IMG
//                 }
//                 alt="Profile"
//                 className="rounded-3"
//                 style={{
//                   width: "100px",
//                   height: "100px",
//                   objectFit: "cover",
//                   imageRendering: "pixelated",
//                 }}
//               />
//               <div className={` ms-3 ${i18n.language === "ar" ? "me-3" : ""} `}>
//                 <h5 className="mb-0 fs-6 fw-bolder">
//                   {" "}
//                   Dr.{" "}
//                   {location?.state?.doctorDetails &&
//                     location?.state?.doctorDetails?.firstName}{" "}
//                   {location?.state?.doctorDetails &&
//                     location?.state?.doctorDetails?.lastName}
//                 </h5>
//                 <p className="text-muted mb-0">
//                   {location?.state?.doctorDetails &&
//                     location?.state?.doctorDetails?.email}
//                 </p>
//               </div>
//             </div>
//             <div className="d-flex mb-3">
//               <Button
//                 label={t("Block By Date")}
//                 className={` rounded-3 py-2 px-4 fw-500 ${showBlock
//                   ? "border-0 submitbtn text-white"
//                   : "textcolor border-sky-blue cursor-pointer bgwhite fs-14"
//                   }`}
//                 onClick={() => {
//                   setShowBlock(!showBlock);
//                   // setBlockBySlotPayload({
//                   //   clinicId: location?.state?.clinicId,
//                   //   doctorId: location?.state?.doctorId,
//                   //   date: "",
//                   //   timeSlotId: [],
//                   //   reason: "",
//                   // });
//                   setBlockByDatePayload({
//                     clinicId: location?.state.clinicId || 0,
//                     doctorId: location.state.doctorId || 0,
//                     fromDate: "",
//                     toDate: "",
//                     date: "",
//                     weekDay: [""],
//                     timeSlotId: [0],
//                     reason: "",
//                     fromTime: "",
//                     toTime: "",
//                   });

//                   setOnlineSlot([]);
//                   setOfflineSlot([]);
//                 }}
//               />
//               <Button
//                 label={t("Block By slot")}
//                 className={` ms-2 rounded-3 py-2 px-4 fw-500 ${!showBlock
//                   ? "border-0 submitbtn text-white"
//                   : "textcolor cursor-pointer border-sky-blue bgwhite fs-14 "
//                   } ${i18n.language === "ar" ? "me-0 me-sm-2" : ""}`}
//                 onClick={() => {
//                   setShowBlock(!showBlock);
//                   // setBlockByDatePayload({
//                   //   ...blockByDatePayload,
//                   //   clinicId: location?.state?.clinicId || 0,
//                   //   doctorId: location?.state?.doctorId || 0,
//                   //   fromDate: "",
//                   //   toDate: "",
//                   //   reason: "",
//                   // });
//                   setBlockByDatePayload({
//                     clinicId: location?.state.clinicId || 0,
//                     doctorId: location.state.doctorId || 0,
//                     fromDate: "",
//                     toDate: "",
//                     date: "",
//                     weekDay: [""],
//                     timeSlotId: [0],
//                     reason: "",
//                     fromTime: "",
//                     toTime: "",
//                   });
//                 }}
//               />
//             </div>
//             {showBlock ? (
//               <>
//                 <div className="row">
//                   <div className="col-12 col-md-6 col-lg-5">
//                     <label htmlFor="weekDay" className="mt-0">
//                       Week Days
//                     </label>
//                     <Select
//                       isMulti
//                       name="weekDay"
//                       className="basic-multi-select"
//                       classNamePrefix="select"
//                       options={weekDayOptions}
//                       value={weekDayOptions.filter((opt) =>
//                         (blockByDatePayload.weekDay || []).includes(opt.value)
//                       )}
//                       onChange={(selected) =>
//                         setBlockByDatePayload({
//                           ...blockByDatePayload,
//                           weekDay: selected ? selected.map((s) => s.value) : [""],
//                         })
//                       }
//                     />
//                   </div>

//                   <div className="col-12 col-md-6 col-lg-3">
//                     <label htmlFor="username" className="mt-0">
//                       {t("From Date")} <span className="text-danger">*</span>
//                     </label>
//                     <div
//                       className={`input-group  ${i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
//                         }`}
//                     >
//                       <span className="input-group-text">
//                         <img src={CLOCK_VECTOR} alt="clock_vector" />
//                       </span>
//                       <input
//                         type="date"
//                         className="form-control"
//                         placeholder={t("fromTime")}
//                         aria-label={t("fromTime")}
//                         min={todayDate}
//                         value={convertToInputDateFormat(
//                           blockByDatePayload?.fromDate
//                         )}
//                         name="fromDate"
//                         onChange={(e) =>
//                           setBlockByDatePayload(
//                             handleDateChange(e, blockByDatePayload)
//                           )
//                         }
//                       />
//                     </div>
//                   </div>

//                   <div className="col-12 col-md-6 col-lg-3">
//                     <label htmlFor="username" className="mt-0">
//                       {t("To Date")}
//                       <span className="text-danger">*</span>
//                     </label>
//                     <div
//                       className={`input-group  ${i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
//                         }`}
//                     >
//                       <span className="input-group-text">
//                         <img src={CLOCK_VECTOR} alt="clock_vector" />
//                       </span>
//                       <input
//                         type="date"
//                         className="form-control"
//                         placeholder="To Time"
//                         aria-label="To Time"
//                         min={todayDate}
//                         value={convertToInputDateFormat(
//                           blockByDatePayload?.toDate
//                         )}
//                         name="toDate"
//                         onChange={(e) =>
//                           setBlockByDatePayload(
//                             handleDateChange(e, blockByDatePayload)
//                           )
//                         }
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="col-12 col-md-6 col-lg-6">
//                     <TextArea
//                       labelName={t("Reason")}
//                       placeholder={t("Enter Reason")}
//                       className="mb-3"
//                       lableclassName="d-flex justify-content-start"
//                       handleChange={(e) =>
//                         setBlockByDatePayload(
//                           handleFormInput(e, blockByDatePayload)
//                         )
//                       }
//                       name="reason"
//                       value={blockByDatePayload?.reason}
//                       showastrict={true}
//                     />
//                   </div>
//                 </div>
//                 <Button
//                   label={t("Block Date")}
//                   type="button"
//                   className="submitbtn border-0 rounded-3 text-white px-5 py-2 fw-500"
//                   isLoading={isLoading}
//                   onClick={handleBlockAvailabilityByDate}
//                 />
//               </>
//             ) : (
//               <>
//                 <div className="row">
//                   <div className="col-12 col-md-6 col-lg-4">
//                     <label htmlFor="weekDay" className="mt-0">
//                       Week Days
//                     </label>
//                     <Select
//                       isMulti
//                       name="weekDay"
//                       className="basic-multi-select"
//                       classNamePrefix="select"
//                       options={weekDayOptions}
//                       value={weekDayOptions.filter((opt) =>
//                         (blockBySlotPayload.weekDay || []).includes(opt.value)
//                       )}
//                       onChange={(selected) =>
//                         setBlockBySlotPayload({
//                           ...blockBySlotPayload,
//                           weekDay: selected ? selected.map((s) => s.value) : [""],
//                         })
//                       }
//                     />
//                   </div>

//                   <div className="col-12 col-md-6 col-lg-2">
//                     <label htmlFor="username" className="mt-0">
//                       {t("From Date")} <span className="text-danger">*</span>
//                     </label>
//                     <div
//                       className={`input-group  ${i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
//                         }`}
//                     >
//                       <span className="input-group-text">
//                         <img src={CLOCK_VECTOR} alt="clock_vector" />
//                       </span>
//                       <input
//                         type="date"
//                         className="form-control"
//                         placeholder={t("fromTime")}
//                         aria-label={t("fromTime")}
//                         min={todayDate}
//                         value={convertToInputDateFormat(
//                           blockBySlotPayload?.fromDate
//                         )}
//                         name="fromDate"
//                         onChange={(e) =>
//                           setBlockBySlotPayload(
//                             handleDateChange(e, blockBySlotPayload)
//                           )
//                         }
//                       />
//                     </div>
//                   </div>

//                   <div className="col-12 col-md-6 col-lg-2">
//                     <label htmlFor="username" className="mt-0">
//                       {t("To Date")}
//                       <span className="text-danger">*</span>
//                     </label>
//                     <div
//                       className={`input-group  ${i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
//                         }`}
//                     >
//                       <span className="input-group-text">
//                         <img src={CLOCK_VECTOR} alt="clock_vector" />
//                       </span>
//                       <input
//                         type="date"
//                         className="form-control"
//                         placeholder="To Time"
//                         aria-label="To Time"
//                         min={todayDate}
//                         value={convertToInputDateFormat(
//                           blockBySlotPayload?.toDate
//                         )}
//                         name="toDate"
//                         onChange={(e) =>
//                           setBlockBySlotPayload(
//                             handleDateChange(e, blockBySlotPayload)
//                           )
//                         }
//                       />
//                     </div>
//                   </div>
//                   <div className="col-12 col-md-6 col-lg-2">
//                     <label className="mt-0">From Time</label>
//                     <TimePicker
//                       value={
//                         blockBySlotPayload?.fromTime
//                           ? dayjs(blockBySlotPayload.fromTime, "HH:mm")
//                           : null
//                       }
//                       className="form-control"
//                       format="HH:mm"
//                       placeholder="From"
//                       onChange={(time) =>
//                         setBlockBySlotPayload({
//                           ...blockBySlotPayload,
//                           fromTime: time ? dayjs(time).format("HH:mm") : ""
//                         })
//                       }
//                     />
//                   </div>

//                   <div className="col-12 col-md-6 col-lg-2">
//                     <label className="mt-0">To Time</label>
//                     <TimePicker
//                       value={blockBySlotPayload?.toTime ? dayjs(blockBySlotPayload.toTime, "HH:mm") : null}
//                       className="form-control"
//                       format="HH:mm"
//                       placeholder="To"
//                       disabled={!blockBySlotPayload.fromTime} // Jab tak fromTime nahi, disable rahega
//                       disabledTime={() => {
//                         if (!blockBySlotPayload.fromTime) return {};
//                         const from = dayjs(blockBySlotPayload.fromTime, "HH:mm");
//                         return {
//                           disabledHours: () => Array.from({ length: from.hour() }, (_, i) => i),
//                           disabledMinutes: (hour) =>
//                             hour === from.hour() ? Array.from({ length: from.minute() + 1 }, (_, i) => i) : []
//                         };
//                       }}
//                       onChange={(time) =>
//                         setBlockBySlotPayload({
//                           ...blockBySlotPayload,
//                           toTime: time ? dayjs(time).format("HH:mm") : ""
//                         })
//                       }
//                     />


//                   </div>

//                   {/* <div className="col-12 col-md-6 col-lg-3">
//                     <label htmlFor="username" className="mt-0">
//                       {t("Date")} <span className="text-danger">*</span>
//                     </label>
//                     <div className="input-group">
//                       <span className="input-group-text">
//                         <img src={CLOCK_VECTOR} alt="clock_vector" />
//                       </span>
//                       <input
//                         type="date"
//                         label="form Date"
//                         className="form-control"
//                         placeholder="From Time"
//                         min={todayDate}
//                         value={convertToInputDateFormat(
//                           blockByDatePayload?.date
//                         )}
//                         name="date"
//                         // onChange={(e) =>
//                         //   setBlockBySlotPayload(
//                         //     handleDateChange(e, blockBySlotPayload)
//                         //   )
//                         // }
//                         onChange={(e) =>
//                           setBlockByDatePayload(
//                             handleDateChange(e, blockByDatePayload)
//                           )
//                         }
//                       />
//                     </div>
//                   </div> */}
//                   <div className="col-12 col-md-6 col-lg-6 mt-2">
//                     <TextArea
//                       labelName={t("Reason")}
//                       placeholder={t("Enter Reason")}
//                       lableclassName="d-flex justify-content-start mt-0"
//                       // handleChange={(e) =>
//                       //   setBlockBySlotPayload(
//                       //     handleFormInput(e, blockBySlotPayload)
//                       //   )
//                       // }
//                       handleChange={(e) =>
//                         setBlockBySlotPayload(
//                           handleFormInput(e, blockBySlotPayload)
//                         )
//                       }
//                       name="reason"
//                       value={blockBySlotPayload?.reason}
//                       showastrict={true}
//                     />
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="col-12">
//                     {onlineSlot && onlineSlot?.length !== 0 && (
//                       <>
//                         <div className="row">
//                           <label htmlFor="username" className="mt-0 ">
//                             Online slots <span className="text-danger ">*</span>
//                           </label>
//                           {onlineSlot &&
//                             onlineSlot?.map((clinicSLot, idx) =>
//                               clinicSLot?.timeSlots?.map((slot) => {
//                                 if (slot?.isBlockedByTime) return null;
//                                 return (
//                                   <div className="col-auto" key={slot?.id}>
//                                     <label className="option-block d-flex">
//                                       <div>
//                                         <input
//                                           checked={slotAvailabilityCheck?.includes(
//                                             slot?.id
//                                           )}
//                                           className="form-check-input"
//                                           type="checkbox"
//                                           onChange={() =>
//                                             handleCheckBox(slot?.id)
//                                           }
//                                         />
//                                       </div>
//                                       <div className="ms-2">
//                                         {convertTimeToAmPm(slot?.startTime)} -{" "}
//                                         {convertTimeToAmPm(slot?.endTime)}
//                                       </div>
//                                     </label>
//                                   </div>
//                                 );
//                               })
//                             )}
//                         </div>
//                       </>
//                     )}
//                     {offlineSlot && offlineSlot?.length !== 0 && (
//                       <div className="row mt-2">
//                         <label htmlFor="username" className="mt-0">
//                           Offline slots <span className="text-danger">*</span>
//                         </label>
//                         {offlineSlot &&
//                           offlineSlot?.map((clinicSLot, idx) =>
//                             clinicSLot?.timeSlots?.map((slot) => {
//                               if (slot?.isBlockedByTime) return null; // skip blocked slots

//                               return (
//                                 <div className="col-auto" key={slot?.id}>
//                                   <label className="option-block d-flex">
//                                     <div>
//                                       <input
//                                         checked={slotAvailabilityCheck?.includes(
//                                           slot?.id
//                                         )}
//                                         className="form-check-input"
//                                         type="checkbox"
//                                         onChange={() =>
//                                           handleCheckBox(slot?.id)
//                                         }
//                                       />
//                                     </div>
//                                     <div className="ms-2">
//                                       {convertTimeToAmPm(slot?.startTime)} -{" "}
//                                       {convertTimeToAmPm(slot?.endTime)}
//                                     </div>
//                                   </label>
//                                 </div>
//                               );
//                             })
//                           )}
//                       </div>
//                     )}
//                   </div>
//                 </div>
//                 <Button
//                   label="Block Slot"
//                   className="submitbtn rounded-3 border-0 text-white px-5 py-2 mt-3 fw-500"
//                   isLoading={isLoading}
//                   type="submit"
//                   // onClick={handleBlockAvailabilityBySlot}
//                   onClick={handleBlockAvailabilityBySlot}
//                 />
//               </>
//             )}
//           </div>
//         </div>

//         <TableHeading
//           title={t("Block Availability List")}
//           showbutton={false}
//           showDateinput={true}
//           showsearchinput={false}
//           selectedDate={selectedDate}
//           setSelectedDate={setSelectedDate}
//           todayDate={todayDate}
//         />
//         <div className="table-wrapper">
//           <TableLayout
//             _tblColumns={tableColumns}
//             _rowData={rowData}
//             pending={pending}
//             pagination={true}
//             selectableRows={false}
//             setPending={setPending}
//             _totalRows={totalRows}
//             pageSize={pageSize}
//             setPageSize={setPageSize}
//             setPage={setPage}
//             setSortColumn={setSortColumn}
//             setSortDirection={setSortDirection}
//           />
//         </div>
//         <Modal
//           modalId="blockavailability"
//           heading="Availability Blocked"
//           modalClick={addbuttonClick}
//           iconsrc={BLOCKAVAILABILITYSUCCESS}
//           paragraph="Doctor Availability Blocked . You Can Manage it From Block Availability List Section."
//         />
//       </div>
//     </>
//   );
// };
// export default BlockAvailability;





import React, { useEffect, useRef, useState } from "react";
import TableHeading from "../../components/common/TableHeading";
import Modal from "../../components/common/Model";
import TableLayout from "../../components/layouts/table-layout";
import BreadCrum from "../../components/common/BreadCrum";
import { useTranslation } from "react-i18next";
import {
  BLOCKAVAILABILITYSUCCESS,
  CLOCK_VECTOR,
  LIGHTRESTOREBLOCKAVAILABILITY,
  PROFILE_IMG,
  PROFILE_PICTURE,
  RESTOREBLOCKAVAILABILITY,
} from "../../utils/aap-image-constant";
import Button from "../../components/common/button";
import TextArea from "../../components/common/text-area";
import {
  convertTimeToAmPm,
  convertToInputDateFormat,
  handleDateChange,
  handleFormInput,
  localToUtcTime,
  utcToLocalDayjs,
  utcToLocalTime,
} from "../../utils/form-utils";
import { useLocation, useNavigate } from "react-router-dom";
import { API_RESPONSE, DEFAULT_PAGE_LENGTH } from "../../utils/app-constants";
import { decryptAEStoJSON, toastEmitter } from "../../utils/utilities";
import {
  availabiltySlotListDoctorWise,
  blockDoctorAvailabilityByDates,
  blockDoctorAvailabilityByRecurring,
  blockDoctorAvailabilityByTimeSlot,
  getallClinicDoctorAvaialbilty,
  getExpertiesById,
  restoreBlockAvailabilityAll,
} from "../../hooks/services/api-services";
import { ROUTES } from "../../hooks/routes/routes-constant";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { API_URL } from "../../utils/url-constants";
import { TimePicker } from "antd";
import dayjs from "dayjs";
import Select from "react-select";
const BlockAvailability = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const addbuttonClick = useRef();
  const { value } = useSelector((state) => state?.loggedUser);
  const userData = decryptAEStoJSON(value);
  const isFirstRender = useRef(true);
  const [showBlock, setShowBlock] = useState(true);
  const [pending, setPending] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_LENGTH);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [rowData, setRowData] = useState([]);
  const [blockType, setBlockType] = useState("date");
  const [expertiesData, setExpertiesData] = useState([]);
  const [selectedExpertise, setSelectedExpertise] = useState("");

  const [selectedDate, setSelectedDate] = useState("");
  const dateNew = new Date();
  const todayDate = isNaN(dateNew) ? null : dateNew.toISOString().split("T")[0];

  const [slotAvailabilityCheck, setSlotAvailabilityCheck] = useState([]);
  const [blockByDatePayload, setBlockByDatePayload] = useState({
    clinicId: location?.state.clinicId || 0,
    doctorId: location.state.doctorId || 0,
    date: "",
    toDate: "",
    fromDate: "",
    weekDay: [],
    timeSlotId: [0],
    reason: "",
    fromTime: "",
    toTime: "",
  });

  const [blockBySlotPayload, setBlockBySlotPayload] = useState({
    clinicId: location?.state?.clinicId,
    doctorId: location?.state?.doctorId,
    date: "",
    timeSlotId: [],
    reason: "",
  });

  const handleCheckBox = (id) => {
    if (slotAvailabilityCheck?.includes(id)) {
      setSlotAvailabilityCheck(slotAvailabilityCheck?.filter((x) => x !== id));
    } else {
      setSlotAvailabilityCheck([...slotAvailabilityCheck, id]);
    }
  };

  useEffect(() => {
    setBlockByDatePayload(prev => ({
      ...prev,
      timeSlotId:
        slotAvailabilityCheck.length > 0
          ? slotAvailabilityCheck
          : [],
    }));
  }, [slotAvailabilityCheck]);

  // view availability sloct list doctor wise
  const [offlineSlot, setOfflineSlot] = useState([]);
  const [onlineSlot, setOnlineSlot] = useState([]);
  const [viewDoctorSlotPayload, setViewDoctorSlotPayload] = useState({
    clinicId: userData?.id,
    doctorId: location?.state?.doctorId,
    date: blockByDatePayload?.date,
    languageType: i18n.language,
    expertise: selectedExpertise
  });

  useEffect(() => {
    setViewDoctorSlotPayload(prev => ({
      ...prev,
      date: blockByDatePayload?.date,
      expertise: selectedExpertise,
    }));
  }, [blockByDatePayload?.date, selectedExpertise]);

  const fetchAvailabilityData = async () => {
    try {
      const response = await availabiltySlotListDoctorWise(
        viewDoctorSlotPayload
      );
      if (response?.data?.status !== 200) {
        if (isFirstRender.current) {
          toastEmitter("error", response?.data?.message);
        }
        setOfflineSlot([]);
        setOnlineSlot([]);
      } else {
        setOfflineSlot(response?.data?.data?.offlineSlots);
        setOnlineSlot(response?.data?.data?.onlineSlots);
      }
    } catch (err) {
      if (isFirstRender.current) {
        toastEmitter("error", API_RESPONSE?.MESSAGE_503);
      }
    } finally {
      isFirstRender.current = false;
    }
  };

  useEffect(() => {
    if (viewDoctorSlotPayload?.doctorId && viewDoctorSlotPayload?.date) {
      fetchAvailabilityData();
    }
  }, [viewDoctorSlotPayload]);

 const handleBlockAvailabilityRecurring = async () => {
  if (!blockByDatePayload?.fromDate?.trim()) {
    return toastEmitter("error", "From date is mandatory!");
  }

  if (!blockByDatePayload?.toDate?.trim()) {
    return toastEmitter("error", "To date is mandatory!");
  }

  // if (!blockByDatePayload?.fromTime) {
  //   return toastEmitter("error", "From time required!");
  // }

  // if (!blockByDatePayload?.toTime) {
  //   return toastEmitter("error", "To time required!");
  // }

  // if (!blockByDatePayload?.weekDay?.length) {
  //   return toastEmitter("error", "Select weekdays!");
  // }

  if (!blockByDatePayload?.reason?.trim()) {
    return toastEmitter("error", "Reason required!");
  }

  setIsLoading(true);

  try {
    const payload = {
      clinicId: blockByDatePayload.clinicId,
      doctorId: blockByDatePayload.doctorId,
      fromDate: blockByDatePayload.fromDate,
      toDate: blockByDatePayload.toDate,
      fromTime: blockByDatePayload.fromTime,
      toTime: blockByDatePayload.toTime,
      weekDay: blockByDatePayload.weekDay,
      reason: blockByDatePayload.reason,
    };

    const response =
      await blockDoctorAvailabilityByRecurring(payload);

    if (response?.data?.status === 200) {
      toastEmitter("success", response?.data?.message);

      setBlockByDatePayload(prev => ({
        ...prev,
        fromDate: "",
        toDate: "",
        fromTime: "",
        toTime: "",
        weekDay: [],
        reason: "",
      }));

      getAllBlockAvailabilityList();
      addbuttonClick.current.click();
    } else {
      toastEmitter("error", response?.data?.message);
    }
  } catch {
    toastEmitter("error", API_RESPONSE.MESSAGE_503);
  } finally {
    setIsLoading(false);
  }
};
 const handleBlockAvailabilityByDate = async () => {
    if (!blockByDatePayload?.fromDate?.trim()) {
      return toastEmitter("error", "From date is mandatory!");
    }

    if (!blockByDatePayload?.toDate?.trim()) {
      return toastEmitter("error", "To date is mandatory!");
    }

    if (!blockByDatePayload?.reason?.trim()) {
      return toastEmitter("error", "Reason is mandatory!");
    }

    setIsLoading(true);

    try {
      const payload = {
        clinicId: blockByDatePayload.clinicId,
        doctorId: blockByDatePayload.doctorId,
        fromDate: blockByDatePayload.fromDate,
        toDate: blockByDatePayload.toDate,
        weekDay: blockByDatePayload.weekDay.filter(Boolean),
        reason: blockByDatePayload.reason,
      };

      const response =
        await blockDoctorAvailabilityByDates(payload);

      if (response?.data?.status === 200) {
        toastEmitter("success", response?.data?.message);

        setBlockByDatePayload(prev => ({
          ...prev,
          fromDate: "",
          toDate: "",
          weekDay: [],
          reason: "",
        }));

        getAllBlockAvailabilityList();
        addbuttonClick.current.click();
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchDoctorExperties = async () => {
    const doctorId = location?.state?.doctorId;
    if (!doctorId) return;

    try {
      const res = await getExpertiesById(doctorId, i18n.language);

      if (res?.data?.status === 200) {
        const list = res?.data?.data?.expertiseName || [];

        setExpertiesData(list);

        if (list.length > 0) {
          setSelectedExpertise(list[0].expertiseName);
        }
      }
    } catch {
      setExpertiesData([]);
    }
  };
  useEffect(() => {
    fetchDoctorExperties();
  }, [i18n.language]);

  // block availability slot wise
  const handleBlockAvailabilityBySlot = async () => {
    if (!blockByDatePayload?.date?.trim()) {
      return toastEmitter("error", "Block Date is mandatory!");
    }

    if (!blockByDatePayload?.reason?.trim()) {
      return toastEmitter("error", "Reason is mandatory!");
    }

    // if (!blockByDatePayload?.timeSlotId?.length) {
    //   return toastEmitter("error", "Select at least one slot!");
    // }

    setIsLoading(true);

    try {
      const payload = {
        clinicId: blockByDatePayload.clinicId,
        doctorId: blockByDatePayload.doctorId,
        date: blockByDatePayload.date,
        timeSlotId: blockByDatePayload.timeSlotId,
        fromTime: blockByDatePayload.fromTime,
        toTime: blockByDatePayload.toTime,
        reason: blockByDatePayload.reason,
      };

      const response =
        await blockDoctorAvailabilityByTimeSlot(payload);

      if (response?.data?.status === 200) {
        toastEmitter("success", response?.data?.message);

        setSlotAvailabilityCheck([]);
        setOnlineSlot([]);
        setOfflineSlot([]);

        setBlockByDatePayload((prev) => ({
          ...prev,
          date: "",
          timeSlotId: [],
          fromTime: "",
          toTime: "",
          reason: "",
        }));

        getAllBlockAvailabilityList();
        addbuttonClick.current.click();
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    setBlockByDatePayload(prev => ({
      ...prev,
      timeSlotId: slotAvailabilityCheck
    }));
  }, [slotAvailabilityCheck]);


  const handleDataBack = () => {
    navigate(ROUTES.AVAILABILITY);
  };

  //get all  block availability list
  const payload = {
    clinicId: location?.state?.clinicId || 0,
    doctorId: location?.state?.doctorId,
    pageIndex: page || 0,
    pageSize: pageSize || DEFAULT_PAGE_LENGTH,
    direction: sortDirection || "desc",
    date: selectedDate,
    filterByFieldName: sortColumn || "id",
    languageType: i18n.language,
  };

  const getAllBlockAvailabilityList = async () => {
    setPending(true);
    try {
      const response = await getallClinicDoctorAvaialbilty(payload);
      if (response?.data?.status !== 200) {
        setRowData([]);
         setTotalRows(0);
      } else {
        const resData = response.data.data;

      setRowData(resData?.doctorAvailabilityResponseList || []);
      setTotalRows(resData?.totalElement || 0);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    getAllBlockAvailabilityList();
  }, [selectedDate, page, pageSize, sortDirection, sortColumn, i18n.language]);

  // restore block availability for date and slot
  const [selectedSlotId, setSelectedSlotId] = useState(null);
  const handleSlotClick = (slotId) => {
    setSelectedSlotId((prev) => (prev === slotId ? null : slotId));
  };
  const handleRestoreBlockAvailability = async (id) => {
    try {
      const response = await restoreBlockAvailabilityAll(id);
      if (response?.data?.status !== 200) {
        toastEmitter("error", response?.data?.message);
      } else {
        toastEmitter("success", response?.data?.message);
        setSelectedSlotId(null);
        getAllBlockAvailabilityList();
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    } finally {
    }
  };

  // list of block by date and block by slot
  const tableColumns = [
    {
      name: t("S.No"),
      width: "100px",
      selector: (row, index) => `${page * pageSize + index + 1}`,
    },
    {
      name: t("Block Date"),
      width: "170px",
      selector: (row) => row?.date,
    },
    {
      name: t("Block Time"),
      width: "400px",
      selector: (row) => {
        console.log("ROW DATA:", row);

        return row?.timeSlots?.length === 0 ? (
          "Block For Full Day"
        ) : (
          <div className="table-cell-content d-flex flex-wrap">
            {row?.timeSlots?.map((slot) => {
              const isSelected = selectedSlotId === slot?.id;

              return (
                <div
                  key={slot?.id}
                  className="cursor-pointer me-1 mt-1"
                  onClick={() => handleSlotClick(slot?.id)}
                >
                  <p
                    className={`rounded fs-12 p-2 fw-500 mb-0 ${isSelected
                        ? "buttonColor text-white"
                        : "buttonLightColor"
                      }`}
                  >
                    {utcToLocalTime(slot?.fromTime)} -{" "}
                    {utcToLocalTime(slot?.toTime)}
                  </p>
                </div>
              );
            })}
          </div>
        );
      },
    },
    // {
    //   name: t("Block Time"),
    //   width: "400px",
    //   selector: (row) =>
    //     row?.timeSlots?.length === 0 ? (
    //       "Block For Full Day"
    //     ) : (
    //       <>
    //         <div className="table-cell-content d-flex flex-wrap">
    //           {row?.timeSlots &&
    //             row?.timeSlots?.map((slot, i) => {
    //               const isSelected = selectedSlotId === slot?.id;
    //               return (
    //                 <div
    //                   key={slot?.id}
    //                   className={`cursor-pointer me-1 mt-1`} // Add mb-2 for wrapping
    //                   onClick={() => handleSlotClick(slot?.id)}
    //                 >
    //                   <p
    //                     className={`rounded fs-12 p-2 fw-500 mb-0 ${isSelected
    //                       ? "buttonColor text-white"
    //                       : "buttonLightColor"
    //                       }`}
    //                   >
    //                     {/* {convertTimeToAmPm(slot?.fromTime)} -{" "}
    //                     {convertTimeToAmPm(slot?.toTime)} */}

    //                     {utcToLocalTime(slot?.startTime)} - {utcToLocalTime(slot?.endTime)}

    //                   </p>
    //                 </div>
    //               );
    //             })}
    //         </div>
    //       </>
    //     ),
    // },
    {
      name: t("Reason"),
      selector: (row) =>
        row?.isBlockedByDay ? row.reason : row?.timeSlotReason,
    },
    {
      name: t("Restore Block"),
      selector: (row) => row?.date,
      cell: (row) => {
        const hasNoSlots = row?.timeSlots?.length === 0;
        const isSelectedSlotInRow = row?.timeSlots?.some(
          (slot) => slot?.id === selectedSlotId
        );
        const isAnySlotSelected = Boolean(selectedSlotId);
        if (hasNoSlots) {
          return (
            <button
              className="unset-property"
              onClick={() => handleRestoreBlockAvailability(row?.id)}
              disabled={isAnySlotSelected}
            >
              <img
                src={
                  isAnySlotSelected
                    ? LIGHTRESTOREBLOCKAVAILABILITY
                    : RESTOREBLOCKAVAILABILITY
                }
                alt=""
              />
            </button>
          );
        } else {
          return (
            <button
              className="unset-property"
              disabled={!isSelectedSlotInRow}
              onClick={() => handleRestoreBlockAvailability(selectedSlotId)}
            >
              <img
                src={
                  isSelectedSlotInRow
                    ? RESTOREBLOCKAVAILABILITY
                    : LIGHTRESTOREBLOCKAVAILABILITY
                }
                alt=""
              />
            </button>
          );
        }
      },
    },
  ];

  // block week days options
  const weekDayOptions = [
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
    { value: "Sunday", label: "Sunday" },
  ];

  return (
    <>
      <div className="main_datatable my-lg-3 my-2">
        <div>
          <BreadCrum
            firstData={t("Availability Management")}
            iconshow1={true}
            secondData={t("Block Availability")}
            onFirstDataClick={handleDataBack}
          />
          <div className="Blockavailability_Content p-2 mb-3">
            <div className="d-flex flex-wrap align-items-center mb-3">
              <img
                src={
                  location?.state?.doctorDetails?.image
                    ? `${API_URL?.ServerURL}${location?.state?.doctorDetails?.image}`
                    : PROFILE_IMG
                }
                alt="Profile"
                className="rounded-3"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                  imageRendering: "pixelated",
                }}
              />
              <div className={` ms-3 ${i18n.language === "ar" ? "me-3" : ""} `}>
                <h5 className="mb-0 fs-6 fw-bolder">
                  {" "}
                  Dr.{" "}
                  {location?.state?.doctorDetails &&
                    location?.state?.doctorDetails?.firstName}{" "}
                  {location?.state?.doctorDetails &&
                    location?.state?.doctorDetails?.lastName}
                </h5>
                <p className="text-muted mb-0">
                  {location?.state?.doctorDetails &&
                    location?.state?.doctorDetails?.email}
                </p>
              </div>
            </div>
            <div className="d-flex mb-3">
              <Button
                label={t("Block By Date")}
                className={` rounded-3 py-2 px-4 fw-500 ${blockType === "date"
                  ? "border-0 submitbtn text-white"
                  : "textcolor border-sky-blue cursor-pointer bgwhite fs-14"
                  }`}

                onClick={() => {
                  setBlockType("date");
                  setBlockByDatePayload({
                    clinicId: location?.state.clinicId || 0,
                    doctorId: location.state.doctorId || 0,
                    fromDate: "",
                    toDate: "",
                    date: "",
                    weekDay: [],
                    timeSlotId: [],
                    reason: "",
                    fromTime: "",
                    toTime: "",
                  });

                  setOnlineSlot([]);
                  setOfflineSlot([]);
                }}
              />
              <Button
                label={t("Block By slot")}
                className={` ms-2 rounded-3 py-2 px-4 fw-500 ${blockType === "slot"
                  ? "border-0 submitbtn text-white"
                  : "textcolor cursor-pointer border-sky-blue bgwhite fs-14 "
                  } ${i18n.language === "ar" ? "me-0 me-sm-2" : ""}`}
                onClick={() => {
                  setBlockType('slot');
                  setBlockByDatePayload({
                    clinicId: location?.state.clinicId || 0,
                    doctorId: location.state.doctorId || 0,
                    fromDate: "",
                    toDate: "",
                    date: "",
                    weekDay: [],
                    timeSlotId: [0],
                    reason: "",
                    fromTime: "",
                    toTime: "",
                  });
                }}
              />

              <Button
                label={t("Block Recuring")}
                className={` ms-2 rounded-3 py-2 px-4 fw-500 ${blockType === "recurring"
                  ? "border-0 submitbtn text-white"
                  : "textcolor cursor-pointer border-sky-blue bgwhite fs-14 "
                  } ${i18n.language === "ar" ? "me-0 me-sm-2" : ""}`}
                onClick={() => {
                  setBlockType('recurring');
                  setBlockByDatePayload({
                    clinicId: location?.state.clinicId || 0,
                    doctorId: location.state.doctorId || 0,
                    fromDate: "",
                    toDate: "",
                    date: "",
                    weekDay: [],
                    timeSlotId: [0],
                    reason: "",
                    fromTime: "",
                    toTime: "",
                  });
                }}
              />
            </div>
            {blockType === "date" && (
              <>
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-5">
                    <label htmlFor="weekDay" className="mt-0">
                      Week Days
                    </label>
                    <Select
                      isMulti
                      name="weekDay"
                      className="basic-multi-select"
                      classNamePrefix="select"
                      options={weekDayOptions}
                      value={weekDayOptions.filter((opt) =>
                        (blockByDatePayload.weekDay || []).includes(opt.value)
                      )}
                      onChange={(selected) =>
                        setBlockByDatePayload({
                          ...blockByDatePayload,
                          weekDay: selected ? selected.map((s) => s.value) : [""],
                        })
                      }
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-3">
                    <label htmlFor="username" className="mt-0">
                      {t("From Date")} <span className="text-danger">*</span>
                    </label>
                    <div
                      className={`input-group  ${i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
                        }`}
                    >
                      <span className="input-group-text">
                        <img src={CLOCK_VECTOR} alt="clock_vector" />
                      </span>
                      <input
                        type="date"
                        className="form-control"
                        placeholder={t("fromTime")}
                        aria-label={t("fromTime")}
                        min={todayDate}
                        value={convertToInputDateFormat(
                          blockByDatePayload?.fromDate
                        )}
                        name="fromDate"
                        onChange={(e) =>
                          setBlockByDatePayload(
                            handleDateChange(e, blockByDatePayload)
                          )
                        }
                      />
                    </div>
                  </div>

                  <div className="col-12 col-md-6 col-lg-3">
                    <label htmlFor="username" className="mt-0">
                      {t("To Date")}
                      <span className="text-danger">*</span>
                    </label>
                    <div
                      className={`input-group  ${i18n.language === "ar" ? "flex-row-reverse" : "flex-row"
                        }`}
                    >
                      <span className="input-group-text">
                        <img src={CLOCK_VECTOR} alt="clock_vector" />
                      </span>
                      <input
                        type="date"
                        className="form-control"
                        placeholder="To Time"
                        aria-label="To Time"
                        min={todayDate}
                        value={convertToInputDateFormat(
                          blockByDatePayload?.toDate
                        )}
                        name="toDate"
                        onChange={(e) =>
                          setBlockByDatePayload(
                            handleDateChange(e, blockByDatePayload)
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-6">
                    <TextArea
                      labelName={t("Reason")}
                      placeholder={t("Enter Reason")}
                      className="mb-3"
                      lableclassName="d-flex justify-content-start"
                      handleChange={(e) =>
                        setBlockByDatePayload(
                          handleFormInput(e, blockByDatePayload)
                        )
                      }
                      name="reason"
                      value={blockByDatePayload?.reason}
                      showastrict={true}
                    />
                  </div>
                </div>
                <Button
                  label={t("Block Date")}
                  type="button"
                  className="submitbtn border-0 rounded-3 text-white px-5 py-2 fw-500"
                  isLoading={isLoading}
                  onClick={handleBlockAvailabilityByDate}
                />
              </>
            )}
            {blockType === "slot" && (
              <>
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-3">
                    <label className="mt-0">From Time</label>
                    <TimePicker
                      // value={
                      //   blockByDatePayload?.fromTime
                      //     ? dayjs(blockByDatePayload.fromTime, "HH:mm")
                      //     : null
                      // }

                      value={utcToLocalDayjs(blockByDatePayload.fromTime)}
                      className="form-control"
                      format="HH:mm"
                      placeholder="From"
                      onChange={(time) =>
                        setBlockByDatePayload({
                          ...blockByDatePayload,
                          fromTime: localToUtcTime(time)
                          // fromTime: time ? dayjs(time).format("HH:mm") : ""
                        })
                      }
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-3">
                    <label className="mt-0">To Time</label>
                    <TimePicker
                      // value={blockByDatePayload?.toTime ? dayjs(blockByDatePayload.toTime, "HH:mm") : null}
                      value={utcToLocalDayjs(blockByDatePayload.toTime)}
                      className="form-control"
                      format="HH:mm"
                      placeholder="To"
                      disabled={!blockByDatePayload.fromTime} // Jab tak fromTime nahi, disable rahega
                      disabledTime={() => {
                        if (!blockByDatePayload.fromTime) return {};
                        // const from = dayjs(blockByDatePayload.fromTime, "HH:mm");
                        const from = utcToLocalDayjs(blockByDatePayload.fromTime);

                        return {
                          disabledHours: () => Array.from({ length: from.hour() }, (_, i) => i),
                          disabledMinutes: (hour) =>
                            hour === from.hour() ? Array.from({ length: from.minute() + 1 }, (_, i) => i) : []
                        };
                      }}
                      onChange={(time) =>
                        setBlockByDatePayload({
                          ...blockByDatePayload,
                          // toTime: time ? dayjs(time).format("HH:mm") : ""
                          toTime: localToUtcTime(time)

                        })
                      }
                    />


                  </div>

                  <div className="col-12 col-md-6 col-lg-3">
                    <label htmlFor="username" className="mt-0">
                      {t("Date")} <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <img src={CLOCK_VECTOR} alt="clock_vector" />
                      </span>
                      <input
                        type="date"
                        label="form Date"
                        className="form-control"
                        placeholder="From Time"
                        min={todayDate}
                        value={convertToInputDateFormat(
                          blockByDatePayload?.date
                        )}
                        name="date"
                        // onChange={(e) =>
                        //   setBlockBySlotPayload(
                        //     handleDateChange(e, blockBySlotPayload)
                        //   )
                        // }
                        onChange={(e) =>
                          setBlockByDatePayload(
                            handleDateChange(e, blockByDatePayload)
                          )
                        }
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-6 mt-2">
                    <TextArea
                      labelName={t("Reason")}
                      placeholder={t("Enter Reason")}
                      lableclassName="d-flex justify-content-start mt-0"
                      // handleChange={(e) =>
                      //   setBlockBySlotPayload(
                      //     handleFormInput(e, blockBySlotPayload)
                      //   )
                      // }
                      handleChange={(e) =>
                        setBlockByDatePayload(
                          handleFormInput(e, blockByDatePayload)
                        )
                      }
                      name="reason"
                      value={blockByDatePayload?.reason}
                      showastrict={true}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    {onlineSlot && onlineSlot?.length !== 0 && (
                      <>
                        <div className="row">
                          <label htmlFor="username" className="mt-0 ">
                            Online slots <span className="text-danger ">*</span>
                          </label>
                          {onlineSlot &&
                            onlineSlot?.map((clinicSLot, idx) =>
                              clinicSLot?.timeSlots?.map((slot) => {
                                if (slot?.isBlockedByTime) return null;
                                console.log(slot);
                                return (
                                  <div className="col-auto" key={slot?.id}>
                                    <label className="option-block d-flex">
                                      <div>
                                        <input
                                          checked={slotAvailabilityCheck?.includes(
                                            slot?.id
                                          )}
                                          className="form-check-input"
                                          type="checkbox"
                                          onChange={() =>
                                            handleCheckBox(slot?.id)
                                          }
                                        />
                                      </div>
                                      <div className="ms-2">
                                        {/* {convertTimeToAmPm(slot?.startTime)} -{" "}
                                        {convertTimeToAmPm(slot?.endTime)} */}
                                        {utcToLocalTime(slot?.startTime)} - {utcToLocalTime(slot?.endTime)}

                                      </div>
                                    </label>
                                  </div>
                                );
                              })
                            )}
                        </div>
                      </>
                    )}
                    {offlineSlot && offlineSlot?.length !== 0 && (
                      <div className="row mt-2">
                        <label htmlFor="username" className="mt-0">
                          Offline slots <span className="text-danger">*</span>
                        </label>
                        {offlineSlot &&
                          offlineSlot?.map((clinicSLot, idx) =>
                            clinicSLot?.timeSlots?.map((slot) => {
                              if (slot?.isBlockedByTime) return null; // skip blocked slots

                              return (
                                <div className="col-auto" key={slot?.id}>
                                  <label className="option-block d-flex">
                                    <div>
                                      <input
                                        checked={slotAvailabilityCheck?.includes(
                                          slot?.id
                                        )}
                                        className="form-check-input"
                                        type="checkbox"
                                        onChange={() =>
                                          handleCheckBox(slot?.id)
                                        }
                                      />
                                    </div>
                                    <div className="ms-2">
                                      {/* {convertTimeToAmPm(slot?.startTime)} -{" "}
                                      {convertTimeToAmPm(slot?.endTime)} */}
                                      {utcToLocalTime(slot?.startTime)} - {utcToLocalTime(slot?.endTime)}

                                    </div>
                                  </label>
                                </div>
                              );
                            })
                          )}
                      </div>
                    )}
                  </div>
                </div>
                <Button
                  label="Block Slot"
                  className="submitbtn rounded-3 border-0 text-white px-5 py-2 mt-3 fw-500"
                  isLoading={isLoading}
                  type="submit"
                  onClick={handleBlockAvailabilityBySlot}
                />
              </>
            )}

            {blockType === "recurring" && (
              <>
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-4">
                    <label>Week Days</label>
                    <Select
                      isMulti
                      name="weekDay"
                      classNamePrefix="select"
                      options={weekDayOptions}
                      value={weekDayOptions.filter((opt) =>
                        (blockByDatePayload.weekDay || []).includes(opt.value)
                      )}
                      onChange={(selected) =>
                        setBlockByDatePayload({
                          ...blockByDatePayload,
                          weekDay: selected ? selected.map((s) => s.value) : [],
                        })
                      }
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-4">
                    <label>From Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={convertToInputDateFormat(blockByDatePayload?.fromDate)}
                      name="fromDate"
                      onChange={(e) =>
                        setBlockByDatePayload(handleDateChange(e, blockByDatePayload))
                      }
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-4">

                    <label>To Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={convertToInputDateFormat(blockByDatePayload?.toDate)}
                      name="toDate"
                      onChange={(e) =>
                        setBlockByDatePayload(handleDateChange(e, blockByDatePayload))
                      }
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-12 col-md-6 col-lg-4">
                    <label className="mt-0">From Time</label>
                    <TimePicker
                      // value={
                      //   blockByDatePayload?.fromTime
                      //     ? dayjs(blockByDatePayload.fromTime, "HH:mm")
                      //     : null
                      // }
                      value={utcToLocalDayjs(blockByDatePayload?.fromTime)}

                      className="form-control"
                      format="HH:mm"
                      placeholder="From"
                      onChange={(time) =>
                        setBlockByDatePayload({
                          ...blockByDatePayload,
                          // fromTime: time ? dayjs(time).format("HH:mm") : ""
                          fromTime: localToUtcTime(time)
                        })
                      }
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-4">
                    <label className="mt-0">To Time</label>
                    <TimePicker
                      // value={
                      //   blockByDatePayload?.toTime
                      //     ? dayjs(blockByDatePayload.toTime, "HH:mm")
                      //     : null
                      // }
                      value={utcToLocalDayjs(blockByDatePayload?.toTime)}

                      className="form-control"
                      format="HH:mm"
                      placeholder="To"
                      onChange={(time) =>
                        setBlockByDatePayload({
                          ...blockByDatePayload,
                          // toTime: time ? dayjs(time).format("HH:mm") : ""
                          toTime: localToUtcTime(time)

                        })
                      }
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-12 col-md-6">
                    <TextArea
                      labelName={t("Reason")}
                      placeholder={t("Enter Reason")}
                      handleChange={(e) =>
                        setBlockByDatePayload(handleFormInput(e, blockByDatePayload))
                      }
                      name="reason"
                      value={blockByDatePayload?.reason}
                      showastrict={true}
                    />
                  </div>
                </div>

                <Button
                  label="Block Recurring"
                  className="submitbtn rounded-3 border-0 text-white px-5 py-2 mt-3 fw-500"
                  isLoading={isLoading}
                  onClick={handleBlockAvailabilityRecurring}
                />
              </>
            )}
          </div>
        </div>

        <TableHeading
          title={t("Block Availability List")}
          showbutton={false}
          showDateinput={true}
          showsearchinput={false}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          todayDate={todayDate}
        />
        <div className="table-wrapper">
          <TableLayout
            _tblColumns={tableColumns}
            _rowData={rowData}
            pending={pending}
            pagination={true}
            selectableRows={false}
            setPending={setPending}
            _totalRows={totalRows}
            pageSize={pageSize}
            setPageSize={setPageSize}
            setPage={setPage}
            setSortColumn={setSortColumn}
            setSortDirection={setSortDirection}
          />
        </div>
        <Modal
          modalId="blockavailability"
          heading="Availability Blocked"
          modalClick={addbuttonClick}
          iconsrc={BLOCKAVAILABILITYSUCCESS}
          paragraph="Doctor Availability Blocked . You Can Manage it From Block Availability List Section."
        />
      </div>
    </>
  );
};
export default BlockAvailability;

